import EsClient from '@/api/elasticSearchClient.js'

const RE_ASSET_ID = /((maestro|suifa)-\d+)/
const RE_SUIFA_REF = /[0-9]{2}(_|-|\/|\\)[0-9]{2}(_|-|\/|\\)[A-Z, a-z, 0-9]{4}/
const JobIncludes = [
	'end_date',
	'comments',
	'update',
	'creation_date',
	'storage',
	'descriptor.descriptor_id',
	'descriptor.archived',
	'descriptor.restricted',
	'descriptor.label',
	'descriptor.typing_text',
	'descriptor.tasks.id',
	'descriptor.tasks.label',
	'descriptor.tasks.trigger',
	'priority',
	'priority_text',
	'requestor',
	'progress',
	'has_child',
	'id',
	'due_date',
	'status_text',
	'infos.client',
	'infos.label',
	'infos.title',
	'infos.asset_id',
	'infos.working_directory',
	'status',
	'start_date',
	'tasks.end_date',
	'tasks.update',
	'tasks.creation_date',
	'tasks.planned_date',
	'tasks.trigger',
	'tasks.descriptor_id',
	// TODO fetch task inputs @maestroJobs.showTaskPage()
	'tasks.input',
	'tasks.operator',
	'tasks.operating_zone',
	'tasks.operating_zone_text',
	'tasks.assigned',
	'tasks.parent_task_id',
	'tasks.hostname',
	'tasks.trigger_text',
	'tasks.process_date',
	'tasks.progress',
	'tasks.id',
	'tasks.status_text',
	'tasks.status',
	'tasks.start_date',
	'tasks.output.error',
	'tasks.output.stop',
	'billing.status'
]

const jobsSortMappings = {
	'id': 'id',
	'progress': 'progress',
	'creation_date': 'creation_date',
	'get_status_display': 'status_text',
	'requestor_name': 'requestor.name',
	'label': 'descriptor.label.keyword',
	'last_update': 'update',
	'storage.client.name': 'infos.client.keyword',
	'infos.client': 'infos.client.keyword'
}

const jobsQueryBuilder = (filters, userId) => {
	let computedFrom = (filters.page - 1) * filters.per_page
	let maxFrom = 10000 - filters.per_page
	let from = Math.min(computedFrom, maxFrom)

	let query = {
		size: filters.per_page,
		from: from,
		track_total_hits: true,
		sort: [],
		_source: {
			includes: JobIncludes
		},
		query: {
			bool: {
				must: []
			}
		}
	}

	let sorter = {}
	let sortKey = jobsSortMappings[filters.sorter] || 'id'
	sorter[sortKey] = filters.sorter_asc ? 'asc' : 'desc'
	query.sort.push(sorter)

	if (filters.job_descriptor_id) {
		let termObj = {
			term: {
				'descriptor.descriptor_id': filters.job_descriptor_id
			}
		}
		query.query.bool.must.push(termObj)
	}

	if (filters.job_id) {
		let termObj = {
			term: {
				'id': filters.job_id
			}
		}
		query.query.bool.must.push(termObj)
	}

	if (filters.job_ids) {
		let termObj = {
			terms: {
				'id': filters.job_ids
			}
		}
		query.query.bool.must.push(termObj)
	}

	if (filters.typing) {
		let termObj = {
			term: {
				'descriptor.typing': filters.typing
			}
		}
		query.query.bool.must.push(termObj)
	}

	if (filters.search) {
		let searched = null
		let fields = [
			'descriptor.label',
			'descriptor.tags',
			'infos.client_name',
			'infos.client',
			'infos.title',
			'infos.label',
			'infos.asset_id',
			'infos.working_directory',
			'requestor.name.keyword'
		]
		if (!isNaN(Number(filters.search))) {
			searched = parseInt(filters.search)
			fields.push('id')
		} else {
			searched = `*${filters.search}*`
			searched = filters.search.replace(/-|\/|:/g, ' ')
			searched = searched.trim().split(' ').map(term => {
				return `**${term}**`
			}).join(' AND ')
		}
		query.query.bool.must.push({
			query_string: {
				query: searched,
				analyzer: 'standard',
				fields: fields
			}
		})
	}

	if (filters.status) {
		if (filters.status.length > 0) {
			let termObj = {
				terms: {
					'status': filters.status
				}
			}
			query.query.bool.must.push(termObj)
		}
	}

	if (filters.billing_status) {
		if (filters.billing_status.length > 0) {
			let termObj = {
				terms: {
					'billing.status': filters.billing_status
				}
			}
			query.query.bool.must.push(termObj)
		}
	}

	if (filters.operating_zone) {
		if (filters.operating_zone.length > 0) {
			let nestedObj = {
				nested: {
					path: 'tasks',
					query: {
						bool: {
							must: [
								{
									terms: {
										'tasks.operating_zone': filters.operating_zone
									}
								}
							]
						}
					}
				}
			}
			query.query.bool.must.push(nestedObj)
		}
	}

	if (filters.requestor_id) {
		let termObj = {
			term: {
				'requestor.id': filters.requestor_id
			}
		}
		query.query.bool.must.push(termObj)
	}

	if (filters.assignee_id) {
		if (filters.assignee_id === -1) {
			let nestedObj = {
				nested: {
					path: 'tasks',
					query: {
						bool: {
							must: [
								{
									term: { 'tasks.trigger': 1 }
								},
								{
									term: { 'tasks.status': 0 }
								},
								{
									bool: {
										must_not: [
											{ exists: { field: 'tasks.assigned' } }
										]
									}
								}
							]
						}
					}
				}
			}
			query.query.bool.must.push(nestedObj)
		} else {
			let nestedObj = {
				nested: {
					path: 'tasks',
					query: {
						bool: {
							must: [
								{
									term: {
										'tasks.assigned.id': filters.assignee_id
									}
								}
							]
						}
					}
				}
			}
			query.query.bool.must.push(nestedObj)
		}
	}

	if (filters.customers) {
		if (filters.customers.length > 0) {
			let termObj = {
				terms: {
					'infos.client.keyword': filters.customers
				}
			}
			query.query.bool.must.push(termObj)
		}
	}

	if (filters.job_root === 'yes') {
		if (!query.query.bool.hasOwnProperty('must_not')) {
			query.query.bool.must_not = []
		}
		query.query.bool.must_not.push({
			exists: { field: 'root_jobrequest_id' }
		})
	} else if (filters.job_root === 'no') {
		query.query.bool.must.push({
			exists: { field: 'root_jobrequest_id' }
		})
	}

	if (filters.is_test) {
		query.query.bool.must.push({
			term: {
				is_test: filters.is_test === 'yes'
			}
		})
	}

	if (filters.has_comments) {
		let nestedObj = {
			nested: {
				path: 'comments',
				query: {
					bool: {
						filter: [
							{
								exists: { field: 'comments' }
							}
						]
					}
				}
			}
		}
		if (filters.has_comments === 'yes') {
			query.query.bool.must.push(nestedObj)
		} else if (filters.has_comments === 'no') {
			if (!query.query.bool.hasOwnProperty('must_not')) {
				query.query.bool.must_not = []
			}
			query.query.bool.must_not.push(nestedObj)
		}
	}

	if (filters.requestor_from) {
		let regexpObj = {
			regexp: {
				'requestor.email': {
					value: '@(hiventy|transperfect).com'
				}
			}
		}
		if (filters.requestor_from === 'internal') {
			query.query.bool.must.push(regexpObj)
		} else if (filters.requestor_from === 'external') {
			if (!query.query.bool.hasOwnProperty('must_not')) {
				query.query.bool.must_not = []
			}
			query.query.bool.must_not.push(regexpObj)
		}
	}

	if (filters.created_in || filters.created_out) {
		let rangeObj = {
			range: {
				creation_date: {}
			}
		}
		if (filters.created_in) {
			rangeObj.range.creation_date.gte = filters.created_in
		}
		if (filters.created_out) {
			rangeObj.range.creation_date.lte = filters.created_out
		}
		query.query.bool.must.push(rangeObj)
	}

	if (filters.end_in || filters.end_out) {
		let rangeObj = {
			range: {
				end_date: {}
			}
		}
		if (filters.end_in) {
			rangeObj.range.end_date.gte = filters.end_in
		}
		if (filters.end_out) {
			rangeObj.range.end_date.lte = filters.end_out
		}
		query.query.bool.must.push(rangeObj)
	}

	if (filters.param_key || filters.param_value) {
		let nestedQuery = {
			nested: {
				path: 'parameters',
				query: { bool: { must: [] } }
			}
		}
		if (filters.param_key) {
			nestedQuery.nested.query.bool.must.push({
				term: {
					'parameters.key': filters.param_key
				}
			})
		}
		if (filters.param_value) {
			nestedQuery.nested.query.bool.must.push({
				match_phrase_prefix: {
					'parameters.value': filters.param_value
				}
			})
		}
		query.query.bool.must.push(nestedQuery)
	}

	if (filters.storage_key || filters.storage_value) {
		let nestedQuery = {
			nested: {
				path: 'storage',
				query: { bool: { must: [] } }
			}
		}
		if (filters.storage_key) {
			nestedQuery.nested.query.bool.must.push({
				term: {
					'storage.key': filters.storage_key
				}
			})
		}
		if (filters.storage_value) {
			nestedQuery.nested.query.bool.must.push({
				match_phrase_prefix: {
					'storage.value': filters.storage_value
				}
			})
		}
		query.query.bool.must.push(nestedQuery)
	}

	if (filters.title) {
		let nestedQuery = {
			nested: {
				path: 'storage',
				query: { bool: { must: [] } }
			}
		}
		nestedQuery.nested.query.bool.must.push({
			term: {
				'storage.key': 'title'
			}
		})
		nestedQuery.nested.query.bool.must.push({
			match_phrase_prefix: {
				'storage.value': filters.title
			}
		})
		query.query.bool.must.push(nestedQuery)
	}

	if (filters.no_mixin) {
		if (!query.query.bool.hasOwnProperty('must_not')) {
			query.query.bool.must_not = []
		}
		query.query.bool.must_not.push({
			query_string: {
				analyzer: 'standard',
				query: '*mixin*',
				default_field: 'descriptor.tags'
			}
		})
	}

	return query
}

const listToObj = (list, itemsDesc) => {
	let obj = {}
	if (itemsDesc) {
		for (let i = 0; i < list.length; i++) {
			let itemDesc = itemsDesc[list[i].key]
			if (itemDesc) {
				if (itemDesc.type === 'boolean') {
					if (list[i].value.toLowerCase() === 'true') {
						obj[list[i].key] = true
					} else if (list[i].value.toLowerCase() === 'false') {
						obj[list[i].key] = false
					} else {
						obj[list[i].key] = list[i].value
					}
				} else if (itemDesc.type === 'float') {
					try {
						obj[list[i].key] = parseFloat(list[i].value)
					} catch (error) {
						obj[list[i].key] = list[i].value
					}
				} else if (itemDesc.type === 'integer') {
					try {
						obj[list[i].key] = parseInt(list[i].value)
					} catch (error) {
						obj[list[i].key] = list[i].value
					}
				} else if (itemDesc.type === 'json') {
					try {
						obj[list[i].key] = JSON.parse(list[i].value, null, 2)
					} catch (error) {
						obj[list[i].key] = list[i].value
					}
				} else if (itemDesc.type === 'select') {
					obj[list[i].key] = list[i].value
					// flat() handle label-value choices
					itemDesc.choices.flat().map(choice => {
						// (choice is not typed)
						// eslint-disable-next-line
						if (choice == list[i].value) {
							obj[list[i].key] = choice
						}
					})
				} else if (itemDesc.type.indexOf('multi-') === 0) {
					try {
						obj[list[i].key] = JSON.parse(list[i].value, null, 2)
					} catch (error) {
						obj[list[i].key] = list[i].value
					}
				} else {
					obj[list[i].key] = list[i].value
				}
			} else {
				obj[list[i].key] = list[i].value
			}
		}
	} else {
		for (let i = 0; i < list.length; i++) {
			if (['{', '['].indexOf(list[i].value[0]) > -1) {
				try {
					let value = list[i].value
					obj[list[i].key] = JSON.parse(value)
				} catch (error) {
					obj[list[i].key] = list[i].value
				}
			} else {
				obj[list[i].key] = list[i].value
			}
		}
	}
	return obj
}

const descriptorParamsOrFieldsCaster = (items) => {
	return items.map(item => {
		try {
			item.choices = JSON.parse(item.choices)
		} catch (error) {}
		if (item.default) {
			if (item.type === 'boolean') {
				if (item.default.toLowerCase() === 'true') {
					item.default = true
				} else if (item.default.toLowerCase() === 'false') {
					item.default = false
				}
			} else if (item.type === 'float') {
				try {
					item.default = parseFloat(item.default)
				} catch (error) {}
			} else if (item.type === 'integer') {
				try {
					item.default = parseInt(item.default)
				} catch (error) {}
			} else if (item.type === 'json') {
				try {
					item.default = JSON.parse(item.default)
				} catch (error) {}
			}
		}
		return item
	})
}

const jobBuilder = (job, graph_data) => {
	let taskDesc = job.descriptor.tasks.reduce((obj, task) => {
		obj[task.id] = task
		return obj
	}, {})

	let paramsDesc = null
	if (job.descriptor.parameters) {
		paramsDesc = job.descriptor.parameters.reduce((obj, param) => {
			let choices = []
			try {
				choices = JSON.parse(param.choices)
			} catch (error) {}
			obj[param.name] = {
				type: param.type,
				choices: choices
			}
			return obj
		}, {})
	}

	if (job.storage) job.storage = listToObj(job.storage)
	if (job.parameters) job.parameters = listToObj(job.parameters, paramsDesc)

	job.descriptor_version_id = window.vm.$commons.deepGet(job, 'descriptor.id', '')
	job.descriptor_id = window.vm.$commons.deepGet(job, 'descriptor.descriptor_id', '')
	job.label = window.vm.$commons.deepGet(job, 'descriptor.label', '')
	job.descriptor_archived = window.vm.$commons.deepGet(job, 'descriptor.archived', '')
	job.get_typing_display = window.vm.$commons.deepGet(job, 'descriptor.typing_text', '')
	job.typing = window.vm.$commons.deepGet(job, 'descriptor.typing', '')
	if (graph_data) {
		job.graph_data = job.descriptor.tasks.map(task => {
			delete task.queue_parameters
			delete task.request_parameters
			delete task.request_priority
			delete task.request_priority_text
			delete task.python_parameters
			delete task.python_code
			delete task.context
			return task
		})
	}
	if (job.descriptor.parameters) {
		job.descriptor_parameters = descriptorParamsOrFieldsCaster(job.descriptor.parameters)
	}
	delete job.descriptor

	job.last_update = job.update
	delete job.update

	job.requestor_name = window.vm.$commons.deepGet(job, 'requestor.name', '')
	job.requestor_email = window.vm.$commons.deepGet(job, 'requestor.email', '')
	job.requestor_id = window.vm.$commons.deepGet(job, 'requestor.id', '')
	job.requestor_is_admin = window.vm.$commons.deepGet(job, 'requestor.is_admin', '')
	delete job.requestor

	job.get_status_display = job.status_text
	delete job.status_text

	job.get_priority_display = job.priority_text
	delete job.priority_text

	try {
		let jobStart = new Date(job.creation_date)
		let jobEnd = new Date()
		if (job.end_date) jobEnd = new Date(job.end_date)
		job.process_time = (jobEnd - jobStart) / 1000
		// TODO: process_time is wrong
	} catch (error) {
		job.process_time = 0
	}

	job.tasks = window.vm.$commons.deepGet(job, 'tasks', []).filter(task => {
		return !task.hasOwnProperty('parent_task_id')
	})

	job.tasks.map(task => {
		if (task.input) task.input = listToObj(task.input)
		if (task.output) task.output = listToObj(task.output)
		task.label = window.vm.$commons.deepGet(taskDesc, [task.descriptor_id, 'label'], '')
		task.trigger = window.vm.$commons.deepGet(taskDesc, [task.descriptor_id, 'trigger'], '')
		let redoTaskDescIds = window.vm.$commons.deepGet(taskDesc, [task.descriptor_id, 'redoables_id'], [])
		task.redo = redoTaskDescIds
			.map(redoTaskDescId => {
				let label = window.vm.$commons.deepGet(taskDesc, [redoTaskDescId, 'label'], '')
				return { id: redoTaskDescId, label }
			})
			.filter(redo => redo.label !== '')
		task.get_status_display = task.status_text
		delete task.get_status_display

		if (task.operator) {
			task.operator_name = window.vm.$commons.deepGet(task, 'operator.name', '')
			task.operator_email = window.vm.$commons.deepGet(task, 'operator.email', '')
			task.operator_id = window.vm.$commons.deepGet(task, 'operator.id', '')
			task.operator_is_admin = window.vm.$commons.deepGet(task, 'operator.is_admin', '')
			delete task.operator
		}

		if (task.assigned) {
			task.assigned_name = window.vm.$commons.deepGet(task, 'assigned.name', '')
			task.assigned_email = window.vm.$commons.deepGet(task, 'assigned.email', '')
			task.assigned_id = window.vm.$commons.deepGet(task, 'assigned.id', '')
			task.assigned_is_admin = window.vm.$commons.deepGet(task, 'assigned.is_admin', '')
			delete task.assigned
		}

		try {
			if (task.start_date) {
				let taskStart = new Date(task.start_date)
				let taskProcess = new Date(task.process_date)
				let taskEnd = new Date()
				if (task.end_date) taskEnd = new Date(task.end_date)
				task.exec_time = (taskEnd - taskStart) / 1000
				task.process_time = (taskEnd - taskProcess) / 1000
			}
		} catch (error) {
			task.exec_time = 0
			task.process_time = 0
		}
	})
	return job
}

const escapeSpecialChars = (str) => {
	if (!str) return str
	// Escape reserved characters
	// + - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
	str = str.replace(/\+/g, '\\+')
	str = str.replace(/-/g, '\\-')
	str = str.replace(/=/g, '\\=')
	str = str.replace(/&&/g, '\\&\\&')
	str = str.replace(/\|\|/g, '\\|\\|')
	str = str.replace(/</g, '\\<')
	str = str.replace(/>/g, '\\>')
	str = str.replace(/!/g, '\\!')
	str = str.replace(/\(/g, '\\(')
	str = str.replace(/\)/g, '\\)')
	str = str.replace(/\{/g, '\\{')
	str = str.replace(/\}/g, '\\}')
	str = str.replace(/\[/g, '\\[')
	str = str.replace(/\]/g, '\\]')
	str = str.replace(/\^/g, '\\^')
	str = str.replace(/"/g, '\\"')
	str = str.replace(/~/g, '\\~')
	str = str.replace(/\*/g, '\\*')
	str = str.replace(/\?/g, '\\?')
	str = str.replace(/:/g, '\\:')
	str = str.replace(/\\/g, '\\')
	str = str.replace(/\//g, '\\/')
	return str
}

const EsMaestro = {
	install (Vue, options) {
		Vue.prototype.$EsMaestro = {

			// JOB_REQUEST

			jobrequest_list (filters, userId) {
				return new Promise((resolve, reject) => {
					const query = jobsQueryBuilder(filters, userId)
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let output = {}
							output.count = response.hits.total.value
							output.jobs = response.hits.hits.map(hit => jobBuilder(hit._source))
							resolve(output)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobrequest_list_light (filters) {
				return new Promise((resolve, reject) => {
					let computedFrom = (filters.page - 1) * filters.per_page
					let maxFrom = 10000 - filters.per_page
					let from = Math.min(computedFrom, maxFrom)
					let query = {
						size: filters.per_page,
						from: from,
						track_total_hits: true,
						_source: {
							includes: [
								'id',
								'status',
								'status_text',
								'creation_date',
								'end_date',
								'progress',
								'requestor',
								'descriptor.label',
								'infos'
							]
						},
						query: {
							bool: {
								must: []
							}
						}
					}
					if (filters.user_id) {
						query.query.bool.must.push({
							term: {
								'requestor.id': {
									value: filters.user_id
								}
							}
						})
					}
					if (filters.jd_id) {
						query.query.bool.must.push({
							term: {
								'descriptor.descriptor_id': {
									value: filters.jd_id
								}
							}
						})
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let output = {}
							output.count = response.hits.total.value
							output.jobs = response.hits.hits.map(hit => hit._source)
							resolve(output)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobrequest_read (jrId, includes = []) {
				return new Promise((resolve, reject) => {
					const query = {
						query: {
							bool: {
								must: [
									{
										term: { id: jrId }
									}
								]
							}
						}
					}
					if (includes.length) {
						query._source = { includes: includes }
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let jobSource = window.vm.$commons.deepGet(response, 'hits.hits.0._source', null)
							if (!jobSource) {
								return reject(new Error('Job introuvable ou non-index�'))
							}
							if (includes.length) {
								resolve(jobSource)
							} else {
								let job = jobBuilder(jobSource, true)
								resolve(job)
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jorequest_read_refreshed (jr, try_count = 0) {
				return new Promise((resolve, reject) => {
					if (try_count === 10) {
						reject(new Error('Impossible de reccuperer une job request à jour'))
					}
					try {
						setTimeout(async () => {
							try_count++
							let refreshedJr = await this.jobrequest_read(jr.id)
							if (new Date(refreshedJr.last_update).getTime() > new Date(jr.last_update).getTime()) {
								resolve(refreshedJr)
							} else {
								resolve(this.jorequest_read_refreshed(jr, try_count))
							}
						}, 1000)
					} catch (error) {
						reject(error)
					}
				})
			},

			jobrequest_tree (jrId) {
				return new Promise((resolve, reject) => {
					const query_a = {
						_source: 'root_jobrequest_id',
						size: 1,
						query: {
							bool: {
								must: [
									{
										term: { id: jrId }
									}
								]
							}
						}
					}
					EsClient.getData(query_a, 'jobrequest')
						.then(response => {
							let rootJobrequestId = window.vm.$commons.deepGet(response, 'hits.hits.0._source.root_jobrequest_id', jrId)
							const query_b = {
								_source: {
									includes: [
										'id',
										'status',
										'status_text',
										'progress',
										'descriptor.label',
										'parent_jobrequest_id'
									]
								},
								size: 10000,
								query: {
									bool: {
										should: [
											{
												term: { root_jobrequest_id: rootJobrequestId }
											},
											{
												term: { id: rootJobrequestId }
											}
										]
									}
								}
							}
							return EsClient.getData(query_b, 'jobrequest')
						})
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let directedGraph = {}
							let jrsMap = {}
							let rootJrId = null
							hits.map(hit => {
								jrsMap[hit._source.id] = hit._source
								if (hit._source.parent_jobrequest_id) {
									if (!directedGraph[hit._source.parent_jobrequest_id]) {
										directedGraph[hit._source.parent_jobrequest_id] = []
									}
									directedGraph[hit._source.parent_jobrequest_id].push(hit._source.id)
								} else {
									rootJrId = hit._source.id
								}
							})

							let tree = [[rootJrId]]
							let secu = 99
							let mappedJrs = new Set()
							mappedJrs.add(rootJrId)
							let jrsToMap = hits.length
							while (secu > -1 && mappedJrs.size < jrsToMap) {
								let node = []
								for (const key in directedGraph) {
									let parentId = parseInt(key)
									if (mappedJrs.has(parentId)) {
										let children = directedGraph[parentId]
										children.map(child => {
											if (!mappedJrs.has(child)) node.push(child)
										})
									}
								}
								if (node.length > 0) {
									node.map(item => { mappedJrs.add(item) })
									tree.push([...new Set(node)])
								}
								secu--
							}

							resolve({
								directed_graph: directedGraph,
								tree: tree,
								jrs_map: jrsMap,
								root_jr_id: rootJrId
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobrequest_children_list (jr_id) {
				return new Promise((resolve, reject) => {
					let query = {
						size: 20,
						from: 0,
						track_total_hits: true,
						sort: [{ id: 'desc' }],
						_source: { includes: JobIncludes },
						query: {
							bool: {
								must: [{
									term: { 'parent_jobrequest_id': jr_id }
								}]
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let children = response.hits.hits.map(hit => jobBuilder(hit._source))
							resolve(children)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobrequest_subrequests_manualtasks (jr_id) {
				return new Promise((resolve, reject) => {
					let query = {
						size: 20,
						from: 0,
						track_total_hits: true,
						sort: [{ id: 'desc' }],
						_source: { includes: JobIncludes },
						query: {
							bool: {
								must: [{
									term: { 'parent_jobrequest_id': jr_id }
								}]
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let children = response.hits.hits.map(hit => jobBuilder(hit._source))
							let tasks = []
							children.map(child => {
								child.tasks.map(task => {
									if (task.trigger === window.vm.$getConst('MANUAL')) {
										tasks.push({
											jobrequest: child,
											task: task
										})
									}
								})
							})
							resolve(tasks)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			task_child_jobrequest (task_id) {
				return new Promise((resolve, reject) => {
					let query = {
						size: 1,
						from: 0,
						track_total_hits: true,
						_source: { includes: [ 'id' ] },
						query: {
							bool: {
								must: [{
									term: { 'parent_task_id': task_id }
								}]
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let childJobrequestId = window.vm.$commons.deepGet(response, 'hits.hits.0._source.id', null)
							resolve(childJobrequestId)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			user_jobdescriptors (userId, count, duration) {
				return new Promise((resolve, reject) => {
					if (!duration) duration = 1
					const query = {
						size: 0,
						track_total_hits: true,
						sort: [{ id: 'desc' }],
						_source: '',
						aggs: {
							desc_id: {
								terms: {
									field: 'descriptor.descriptor_id',
									size: count
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											_source: [ 'descriptor.label' ]
										}
									}
								}
							},
							time: {
								date_histogram: {
									field: 'creation_date',
									interval: 'day'
								}
							}
						},
						query: {
							bool: {
								must: [
									{
										term: {
											'requestor.id': userId
										}
									},
									{
										range: {
											creation_date: {
												gte: `now-${duration}M/d`,
												lt: 'now/d'
											}
										}
									}
								],
								must_not: {
									exists: {
										field: 'parent_jobrequest_id'
									}
								}
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let descriptorsBuckets = window.vm.$commons.deepGet(response, 'aggregations.desc_id.buckets', [])
							let timeBuckets = window.vm.$commons.deepGet(response, 'aggregations.time.buckets', [])
							let jds = descriptorsBuckets.map(bucket => {
								return {
									count: bucket.doc_count,
									id: bucket.key,
									label: bucket.top.hits.hits[0]._source.descriptor.label
								}
							})
							resolve({
								jds: jds,
								time: timeBuckets
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptors_enums () {
				return new Promise((resolve, reject) => {
					const query = {
						_source: '',
						size: 0,
						aggs: {
							job_descriptors: {
								terms: {
									field: 'descriptor.descriptor_id',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [
												'descriptor.label',
												'descriptor.description',
												'descriptor.archived',
												'descriptor.protected',
												'descriptor.restricted'
											]
										}
									}
								}
							},
							op_zones: {
								nested: {
									path: 'tasks'
								},
								aggs: {
									zones: {
										terms: {
											field: 'tasks.operating_zone',
											size: 100
										},
										aggs: {
											top: {
												top_hits: {
													size: 1,
													_source: ['tasks.operating_zone_text']
												}
											}
										}
									}
								}
							},
							requestors: {
								terms: {
									field: 'requestor.id',
									size: 1000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											_source: ['requestor.name']
										}
									}
								}
							},
							assignees: {
								nested: {
									path: 'tasks'
								},
								aggs: {
									assignees: {
										terms: {
											field: 'tasks.assigned.id',
											size: 1000
										},
										aggs: {
											top: {
												top_hits: {
													size: 1,
													_source: ['tasks.assigned.name']
												}
											}
										}
									}
								}
							},
							status: {
								terms: {
									field: 'status',
									size: 100
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											_source: [ 'status_text' ]
										}
									}
								}
							},
							customers: {
								terms: {
									field: 'infos.client.keyword',
									size: 10000
								}
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let enums = {
								job_descriptors: [],
								job_descriptors_map: {},
								op_zones: [],
								op_zones_map: {},
								requestors: [],
								requestors_map: {},
								assignees: [],
								assignees_map: {},
								status: [],
								status_map: {},
								customers: []
							}
							let aggs = response.aggregations || {}
							aggs.job_descriptors.buckets.map(bucket => {
								enums.job_descriptors.push({
									count: bucket.doc_count,
									value: bucket.key,
									label: bucket.top.hits.hits[0]._source.descriptor.label,
									description: bucket.top.hits.hits[0]._source.descriptor.description,
									archived: bucket.top.hits.hits[0]._source.descriptor.archived,
									protected: bucket.top.hits.hits[0]._source.descriptor.protected,
									restricted: bucket.top.hits.hits[0]._source.descriptor.restricted
								})
								enums.job_descriptors_map[bucket.key] = bucket.top.hits.hits[0]._source.descriptor.label
							})
							aggs.op_zones.zones.buckets.map(bucket => {
								if (bucket.key) {
									enums.op_zones.push({
										count: bucket.doc_count,
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.operating_zone_text
									})
									enums.op_zones_map[bucket.key] = bucket.top.hits.hits[0]._source.operating_zone_text
								}
							})
							aggs.requestors.buckets.map(bucket => {
								enums.requestors.push({
									count: bucket.doc_count,
									value: bucket.key,
									text: bucket.top.hits.hits[0]._source.requestor.name
								})
								enums.requestors_map[bucket.key] = bucket.top.hits.hits[0]._source.requestor.name
							})
							aggs.assignees.assignees.buckets.map(bucket => {
								enums.assignees.push({
									count: bucket.doc_count,
									value: bucket.key,
									text: bucket.top.hits.hits[0]._source.assigned.name
								})
								enums.assignees_map[bucket.key] = bucket.top.hits.hits[0]._source.assigned.name
							})
							aggs.status.buckets.map(bucket => {
								enums.status.push({
									value: bucket.key,
									text: bucket.top.hits.hits[0]._source.status_text
								})
								enums.status_map[bucket.key] = bucket.top.hits.hits[0]._source.status_text
							})
							aggs.customers.buckets.map(bucket => {
								if (bucket.key) {
									enums.customers.push({
										count: bucket.doc_count,
										value: bucket.key
									})
								}
							})
							resolve(enums)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			prestation_filters_enums () {
				return new Promise((resolve, reject) => {
					let query = {
						_source: '',
						size: 0,
						query: {
							bool: {
								must: [{
									term: {
										'descriptor.typing': window.vm.$getConst('PRESTATION')
									}
								}]
							}
						},
						aggs: {
							requestor: {
								terms: {
									field: 'requestor.id',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [ 'requestor.name' ]
										}
									}
								}
							},
							customer: {
								terms: {
									field: 'infos.client.keyword',
									size: 10000
								}
							}
						}
					}
					EsClient.getData(query, 'jobrequest')
						.then(response => {
							let enums = {
								requestor: [],
								requestor_map: {},
								customer: []
							}
							let aggs = response.aggregations || {}
							if (aggs.requestor) {
								aggs.requestor.buckets.map(bucket => {
									enums.requestor.push({
										count: bucket.doc_count,
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.requestor.name
									})
									enums.requestor_map[bucket.key] = bucket.top.hits.hits[0]._source.requestor.name
								})
							}
							if (aggs.customer) {
								aggs.customer.buckets.map(bucket => {
									if (bucket.key) {
										enums.customer.push({
											count: bucket.doc_count,
											value: bucket.key
										})
									}
								})
							}
							resolve(enums)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// MANUAL TASKS
			task_manual_list_new (from, filters) {
				return new Promise((resolve, reject) => {
					let query = {
						from: from,
						size: filters.per_page,
						track_total_hits: true,
						sort: [],
						_source: {
							includes: [
								'id',
								// 'descriptor.id',
								'descriptor.label',
								'status',
								'status_text',
								// 'progress',
								'update',
								'creation_date',
								// 'start_date',
								'planned_date',
								'end_date',
								'operating_zone',
								'operating_zone_text',
								'operator.id',
								'operator.name',
								'operator.email',
								'assigned.id',
								'assigned.name',
								'assigned.email',
								'jobrequest.id',
								'jobrequest.storage',
								'jobrequest.infos.title',
								'jobrequest.infos.label',
								'jobrequest.infos.working_directory',
								'jobrequest.infos.client',
								'jobrequest.descriptor.descriptor_id',
								'jobrequest.descriptor.label',
								'root_jobrequest.id',
								'root_jobrequest.descriptor.descriptor_id',
								'root_jobrequest.status',
								'root_jobrequest.status_text',
								'root_jobrequest.progress',
								'root_jobrequest.due_date',
								'root_jobrequest.comments',
								'root_jobrequest.infos.title',
								'root_jobrequest.infos.label',
								'root_jobrequest.infos.working_directory',
								'root_jobrequest.infos.client',
								'root_jobrequest.requestor.id',
								'root_jobrequest.requestor.name',
								'root_jobrequest.requestor.email',
								'root_jobrequest.descriptor.label'
							]
						},
						aggs: {
							jr_count: {
								cardinality: { field: 'root_jobrequest.id' }
							},
							progress: {
								cardinality: { field: 'progress' }
							},
							status: {
								terms: { field: 'status_text', size: 100 }
							}
						},
						query: {
							bool: {
								must: [],
								must_not: [{
									terms: { 'status': [6, 7] } // SKIPPED, RESETED
								}]
							}
						}
					}

					let sorter = filters.sorter || 'id'
					if (sorter === 'root_jobrequest.descriptor.label') sorter = 'root_jobrequest.descriptor.label.keyword'
					if (sorter === 'root_jobrequest.infos.client') sorter = 'root_jobrequest.infos.client.keyword'
					if (sorter === 'jobrequest.descriptor.label') sorter = 'jobrequest.descriptor.label.keyword'
					if (sorter === 'descriptor.label') sorter = 'descriptor.label.keyword'
					// if (sorter === 'assigned.name') sorter = 'assigned.name.keyword'
					let sorting = {}
					sorting[sorter] = filters.sorter_asc ? 'asc' : 'desc'
					query.sort.push(sorting)

					if (filters.job_id) {
						query.query.bool.should = []
						query.query.bool.should.push({
							term: {
								'root_jobrequest.id': filters.job_id
							}
						})
						query.query.bool.should.push({
							term: {
								'jobrequest.id': filters.job_id
							}
						})
					}

					if (filters.task_id) {
						query.query.bool.must.push({
							term: {
								'id': filters.task_id
							}
						})
					}

					if (filters.task_label) {
						query.query.bool.must.push({
							term: {
								'descriptor.label.keyword': filters.task_label
							}
						})
					}

					if (filters.root_descriptor_id) {
						query.query.bool.must.push({
							term: {
								'root_jobrequest.descriptor.descriptor_id': filters.root_descriptor_id
							}
						})
					}

					if (filters.parent_descriptor_id) {
						query.query.bool.must.push({
							term: {
								'jobrequest.descriptor.descriptor_id': filters.parent_descriptor_id
							}
						})
					}

					if (filters.has_comments) {
						let nestedObj = {
							nested: {
								path: 'root_jobrequest.comments',
								query: {
									bool: {
										filter: [
											{
												exists: { field: 'root_jobrequest.comments.who' }
											}
										]
									}
								}
							}
						}
						if (filters.has_comments === 'yes') {
							query.query.bool.must.push(nestedObj)
						} else if (filters.has_comments === 'no') {
							query.query.bool.must_not.push(nestedObj)
						}
					}

					if (filters.search) {
						let searched = `*${filters.search}*`
						searched = filters.search.replace(/-|\/|:/g, ' ')
						searched = searched.trim().split(' ').map(term => {
							return `**${term}**`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								query: searched,
								analyzer: 'standard',
								fields: [
									'root_jobrequest.infos.label',
									'root_jobrequest.infos.title',
									'root_jobrequest.infos.client',
									'root_jobrequest.requestor.name.text',
									'jobrequest.infos.label',
									'jobrequest.infos.title',
									'jobrequest.infos.client',
									'jobrequest.requestor.name.text'
								]
							}
						})
					}

					if (filters.requestor_id) {
						query.query.bool.must.push({
							term: {
								'root_jobrequest.requestor.id': filters.requestor_id
							}
						})
					}

					if (filters.planned) {
						let existObj = {
							exists: {
								field: 'planned_date'
							}
						}
						if (filters.planned === 'yes') {
							query.query.bool.must.push(existObj)
						} else if (filters.planned === 'no') {
							query.query.bool.must_not.push(existObj)
						}
					}

					if (filters.requestor_from) {
						let regexpObj = {
							regexp: {
								'root_jobrequest.requestor.email': {
									value: '@(hiventy|transperfect).com'
								}
							}
						}
						if (filters.requestor_from === 'internal') {
							query.query.bool.must.push(regexpObj)
						} else if (filters.requestor_from === 'external') {
							query.query.bool.must_not.push(regexpObj)
						}
					}

					if (filters.task_status.length > 0) {
						query.query.bool.must.push({
							terms: { 'status': filters.task_status }
						})
					}

					if (filters.status.length > 0) {
						query.query.bool.must.push({
							terms: { 'root_jobrequest.status': filters.status }
						})
					}

					if (filters.operating_zone.length > 0) {
						query.query.bool.must.push({
							terms: { 'operating_zone': filters.operating_zone }
						})
					}

					if (filters.assignee_id) {
						if (filters.assignee_id === -1) {
							query.query.bool.must_not.push({ exists: { field: 'tasks.assigned' } })
						} else {
							query.query.bool.must.push({ term: { 'assigned.id': filters.assignee_id } })
						}
					}

					if (filters.customers.length > 0) {
						query.query.bool.must.push({
							terms: { 'root_jobrequest.infos.client.keyword': filters.customers }
						})
					}

					if (filters.param_key || filters.param_value) {
						let nestedQuery = { nested: {
							path: 'root_jobrequest.parameters',
							query: { bool: { must: [] } }
						}}
						if (filters.param_key) {
							nestedQuery.nested.query.bool.must.push({
								term: { 'root_jobrequest.parameters.key': filters.param_key }
							})
						}
						if (filters.param_value) {
							nestedQuery.nested.query.bool.must.push({
								match_phrase_prefix: {
									'root_jobrequest.parameters.value': filters.param_value
								}
							})
						}
						query.query.bool.must.push(nestedQuery)
					}

					if (filters.storage_key || filters.storage_value) {
						let nestedQuery = { nested: {
							path: 'root_jobrequest.storage',
							query: { bool: { must: [] } }
						}}
						if (filters.storage_key) {
							nestedQuery.nested.query.bool.must.push({
								term: { 'root_jobrequest.storage.key': filters.storage_key }
							})
						}
						if (filters.storage_value) {
							nestedQuery.nested.query.bool.must.push({
								match_phrase_prefix: {
									'root_jobrequest.storage.value': filters.storage_value
								}
							})
						}
						query.query.bool.must.push(nestedQuery)
					}

					if (filters.created_in || filters.created_out) {
						let rangeObj = {
							range: {
								'root_jobrequest.creation_date': {}
							}
						}
						if (filters.created_in) {
							rangeObj.range['root_jobrequest.creation_date'].gte = filters.created_in
						}
						if (filters.created_out) {
							rangeObj.range['root_jobrequest.creation_date'].lte = filters.created_out
						}
						query.query.bool.must.push(rangeObj)
					}

					if (filters.end_in || filters.end_out) {
						let rangeObj = {
							range: {
								'root_jobrequest.end_date': {}
							}
						}
						if (filters.end_in) {
							rangeObj.range['root_jobrequest.end_date'].gte = filters.end_in
						}
						if (filters.end_out) {
							rangeObj.range['root_jobrequest.end_date'].lte = filters.end_out
						}
						query.query.bool.must.push(rangeObj)
					}

					if (filters.planned_in || filters.planned_out) {
						let rangeObj = {
							range: {
								'planned_date': {}
							}
						}
						if (filters.end_in) {
							rangeObj.range.planned_date.gte = filters.planned_in
						}
						if (filters.end_out) {
							rangeObj.range.planned_date.lte = filters.planned_out
						}
						query.query.bool.must.push(rangeObj)
					}

					if (filters.in_late) {
						let now = new Date()
						let year = now.getFullYear()
						let month = (now.getMonth() + 1).toString().padStart(2, 0)
						let day = now.getDate().toString().padStart(2, 0)
						let nowString = `${year}-${month}-${day}`
						let rangeObj = {
							range: {
								'root_jobrequest.due_date': {
									lte: nowString,
									gte: nowString
								}
							}
						}
						if (filters.in_late === 'yes') {
							delete rangeObj.range['root_jobrequest.due_date'].lte
						} else if (filters.in_late === 'no') {
							delete rangeObj.range['root_jobrequest.due_date'].gte
						}
						query.query.bool.must.push(rangeObj)
					}

					EsClient.getData(query, 'task_manual')
						.then(response => {
							let tasks = response.hits.hits.map(hit => {
								hit._source.jobrequest.storage = listToObj(hit._source.jobrequest.storage)
								return hit._source
							})
							resolve({
								tasks: tasks,
								task_count: response.hits.total.value,
								jr_count: response.aggregations.jr_count.value
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			user_task_list (userId, status, duration) {
				if (!duration) duration = 1
				if (status === undefined) status = [0, 5]
				return new Promise((resolve, reject) => {
					let query = {
						size: 10000,
						_source: 'end_date',
						query: {
							bool: {
								must: [
									{
										terms: {
											status: status
										}
									},
									{
										term: {
											'operator.id': userId
										}
									},
									{
										range: {
											end_date: {
												gte: `now-${duration}M/d`,
												lt: 'now/d'
											}
										}
									}
								]
							}
						},
						aggs: {
							labels: {
								terms: {
									field: 'descriptor.label.keyword',
									size: 100
								}
							},
							time: {
								date_histogram: {
									field: 'end_date',
									interval: 'day'
								}
							}
						}
					}
					EsClient.getData(query, 'task_manual')
						.then(response => {
							resolve({
								labels: response.aggregations.labels.buckets,
								time: response.aggregations.time.buckets
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			manual_tasks_filters_enums () {
				return new Promise((resolve, reject) => {
					let query = {
						_source: '',
						size: 0,
						aggs: {
							jd: {
								terms: {
									field: 'root_jobrequest.descriptor.descriptor_id',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [ 'root_jobrequest.descriptor.label' ]
										}
									}
								}
							},
							op_zone: {
								terms: {
									field: 'operating_zone',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [ 'operating_zone_text' ]
										}
									}
								}
							},
							requestor: {
								terms: {
									field: 'root_jobrequest.requestor.id',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [ 'root_jobrequest.requestor.name' ]
										}
									}
								}
							},
							assignee: {
								terms: {
									field: 'assigned.id',
									size: 10000
								},
								aggs: {
									top: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [ 'assigned.name' ]
										}
									}
								}
							},
							customer: {
								terms: {
									field: 'root_jobrequest.infos.client.keyword',
									size: 10000
								}
							},
							task: {
								terms: {
									field: 'descriptor.label.keyword',
									size: 10000
								}
							}
						}
					}
					EsClient.getData(query, 'task_manual')
						.then(response => {
							let enums = {
								jd: [],
								jd_map: {},
								op_zone: [],
								op_zone_map: {},
								requestor: [],
								requestor_map: {},
								assignee: [],
								assignee_map: {},
								customer: [],
								task: []
							}
							let aggs = response.aggregations || {}
							if (aggs.jd) {
								aggs.jd.buckets.map(bucket => {
									enums.jd.push({
										count: bucket.doc_count,
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.root_jobrequest.descriptor.label
									})
									enums.jd_map[bucket.key] = bucket.top.hits.hits[0]._source.root_jobrequest.descriptor.label
								})
							}
							if (aggs.op_zone) {
								aggs.op_zone.buckets.map(bucket => {
									if (bucket.key) {
										enums.op_zone.push({
											count: bucket.doc_count,
											value: bucket.key,
											text: bucket.top.hits.hits[0]._source.operating_zone_text
										})
										enums.op_zone_map[bucket.key] = bucket.top.hits.hits[0]._source.operating_zone_text
									}
								})
							}
							if (aggs.requestor) {
								aggs.requestor.buckets.map(bucket => {
									enums.requestor.push({
										count: bucket.doc_count,
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.root_jobrequest.requestor.name
									})
									enums.requestor_map[bucket.key] = bucket.top.hits.hits[0]._source.root_jobrequest.requestor.name
								})
							}
							if (aggs.assignee) {
								aggs.assignee.buckets.map(bucket => {
									enums.assignee.push({
										count: bucket.doc_count,
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.assigned.name
									})
									enums.assignee_map[bucket.key] = bucket.top.hits.hits[0]._source.assigned.name
								})
							}
							if (aggs.customer) {
								aggs.customer.buckets.map(bucket => {
									if (bucket.key) {
										enums.customer.push({
											count: bucket.doc_count,
											value: bucket.key
										})
									}
								})
							}
							if (aggs.task) {
								aggs.task.buckets.map(bucket => {
									enums.task.push({
										count: bucket.doc_count,
										value: bucket.key
									})
								})
							}
							resolve(enums)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			task_manual_read (task_id) {
				return new Promise((resolve, reject) => {
					let query = {
						query: {
							bool: {
								must: [{
									term: { id: task_id }
								}]
							}
						}
					}
					EsClient.getData(query, 'task_manual')
						.then(response => {
							resolve(response.hits.hits[0]._source)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			asset_artefacts (asset_id) {
				return new Promise((resolve, reject) => {
					let query = {
						track_total_hits: true,
						size: 1000,
						_source: {
							includes: [ 'input' ]
						},
						query: {
							bool: {
								must: [
									{
										nested: {
											path: 'input',
											query: {
												bool: {
													must: [
														{
															term: {
																'input.key': 'asset_id'
															}
														},
														{
															match_phrase_prefix: {
																'input.value': asset_id
															}
														}
													]
												}
											}
										}
									},
									{
										nested: {
											path: 'input',
											query: {
												bool: {
													must: [
														{
															term: {
																'input.key': 'artefacts'
															}
														}
													]
												}
											}
										}
									}
								]
							}
						}
					}

					EsClient.getData(query, 'task_manual')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', null)
							let artefacts = false
							for (const hit of hits) {
								let currentArtefact = hit._source.input.find(item => item.key === 'artefacts')
								if (currentArtefact) {
									try {
										artefacts = JSON.parse(currentArtefact.value)
									} catch (error) {
										artefacts = false
									}
								}
							}
							if (artefacts) {
								artefacts.screenshots = artefacts.paths.filter(path => {
									let pathLow = path.toLowerCase()
									return pathLow.indexOf('screenshots/debug/results/screenshot') === 0 &&
									pathLow.lastIndexOf('.jpg') + 1 === pathLow.length - 3
								})
								artefacts.thumbnails = artefacts.paths.filter(path => {
									let pathLow = path.toLowerCase()
									return pathLow.indexOf('screenshots/screenshot') === 0 &&
									pathLow.lastIndexOf('.jpg') + 1 === pathLow.length - 3
								})
								let wavs = artefacts.paths.filter(path => {
									let pathLow = path.toLowerCase()
									return pathLow.indexOf('exploded/') === 0 &&
									pathLow.lastIndexOf('.wav') + 1 === pathLow.length - 3
								})
								artefacts.audio = {}
								for (const wav of wavs) {
									let basename = wav
										.substring(wav.lastIndexOf('/') + 1, wav.lastIndexOf('.'))
										.replace(/\./g, '_')
										.toLowerCase()
									let audio = {
										wav: wav,
										png: null,
										svg: null,
										dat: null
									}
									for (const path of artefacts.paths) {
										let pathLow = path.toLowerCase()
										if (pathLow.indexOf(`graphs/${basename}`) === 0 &&
												pathLow.lastIndexOf('.png') + 1 === pathLow.length - 3) {
											audio.png = path
										} else if (pathLow.indexOf(`graphs/${basename}`) === 0 &&
												pathLow.lastIndexOf('.svg') + 1 === pathLow.length - 3) {
											audio.svg = path
										} else if (pathLow.indexOf(`waveforms/${basename}`) === 0 &&
											pathLow.lastIndexOf('.dat') + 1 === pathLow.length - 3) {
											audio.dat = path
										}
									}
									artefacts.audio[basename] = audio
								}
								resolve(artefacts)
							} else {
								reject(new Error(`Pas d'artefacts pour l'asset ${asset_id}`))
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			find_asset_qc_task_ids (asset_id, task_id) {
				return new Promise((resolve, reject) => {
					let query = {
						track_total_hits: true,
						size: 1000,
						_source: {
							includes: [ 'id', 'operator.name', 'input', 'end_date' ]
						},
						query: {
							bool: {
								must_not: [
									{
										term: {
											id: task_id
										}
									}
								],
								must: [
									{
										term: {
											status: 2
										}
									},
									{
										nested: {
											path: 'input',
											query: {
												bool: {
													must: [
														{
															term: {
																'input.key': 'asset_id'
															}
														},
														{
															match_phrase_prefix: {
																'input.value': asset_id
															}
														}
													]
												}
											}
										}
									},
									{
										nested: {
											path: 'input',
											query: {
												bool: {
													must: [
														{
															term: {
																'input.key': 'form_type'
															}
														},
														{
															match_phrase_prefix: {
																'input.value': 'quality check'
															}
														}
													]
												}
											}
										}
									}
								]
							}
						}
					}

					EsClient.getData(query, 'task_manual')
						.then(response => {
							let qcTasks = response.hits.hits.map(hit => {
								let checkLevel = '-'
								for (const input of hit._source.input) {
									if (input.key === 'check_level') {
										checkLevel = input.value
										break
									}
								}
								return {
									id: hit._source.id,
									end_date: hit._source.end_date,
									operator: hit._source.operator.name,
									check_level: checkLevel
								}
							})
							resolve(qcTasks)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// JOB DESCRIPTOR

			jobdescriptor_list_light (paramTypes) {
				return new Promise((resolve, reject) => {
					const query_a = {
						_source: '',
						track_total_hits: true,
						size: 0,
						aggs: {
							jd: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: { order: 'desc' }
												}
											],
											_source: 'id'
										}
									}
								}
							}
						}
					}
					EsClient.getData(query_a, 'jobdescriptor')
						.then(response => {
							let lastVersionIds = response.aggregations.jd.buckets.map(bucket => {
								return bucket.info.hits.hits[0]._source.id
							})
							const query_b = {
								track_total_hits: true,
								size: 10000,
								sort: [{ id: 'desc' }],
								_source: [
									'descriptor_id',
									'version_number',
									'label',
									'description',
									'archived',
									'protected',
									'restricted',
									'typing'
								],
								query: {
									bool: {
										must: [
											{
												terms: {
													id: lastVersionIds
												}
											}
										]
									}
								},
								aggs: {
									typing: {
										terms: {
											field: 'typing_text',
											size: 100
										},
										aggs: {
											id: {
												top_hits: {
													size: 1,
													sort: [
														{
															id: { order: 'desc' }
														}
													],
													_source: [ 'typing' ]
												}
											}
										}
									}
								}
							}
							if (paramTypes) {
								query_b.query.bool.must.push({
									nested: {
										path: 'parameters',
										query: {
											terms: {
												'parameters.type': paramTypes
											}
										}
									}
								})
								query_b._source.push('parameters.type')
								query_b._source.push('parameters.name')
							}
							return EsClient.getData(query_b, 'jobdescriptor')
						})
						.then(response => {
							let types = window.vm.$commons.deepGet(response, 'aggregations.typing.buckets', [])
								.map(bucket => {
									return {
										text: bucket.key,
										value: window.vm.$commons.deepGet(bucket, 'id.hits.hits.0._source.typing'),
										count: bucket.doc_count
									}
								})
							types.sort((a, b) => {
								if (a.text > b.text) return 1
								if (a.text < b.text) return -1
								return 0
							})
							let jds = []
							response.hits.hits.map(hit => {
								let jd = {
									id: hit._source.descriptor_id,
									versions: hit._source.version_number,
									label: hit._source.label,
									description: hit._source.description,
									archived: hit._source.archived,
									protected: hit._source.protected,
									restricted: hit._source.restricted,
									typing: hit._source.typing
								}
								jds.push(jd)
							})
							jds.sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve({
								jds: jds,
								jds_types: types
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_prestation_list_light (keepStorage) {
				return new Promise((resolve, reject) => {
					const query_a = {
						_source: '',
						track_total_hits: true,
						size: 0,
						aggs: {
							jd: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: { order: 'desc' }
												}
											],
											_source: 'id'
										}
									}
								}
							}
						}
					}
					EsClient.getData(query_a, 'jobdescriptor')
						.then(response => {
							let lastVersionIds = response.aggregations.jd.buckets.map(bucket => {
								return bucket.info.hits.hits[0]._source.id
							})
							const query_b = {
								track_total_hits: true,
								size: 10000,
								sort: [{ id: 'desc' }],
								_source: [
									'descriptor_id',
									'label',
									'description'
								],
								query: {
									bool: {
										must: [
											{
												terms: { id: lastVersionIds }
											},
											{
												term: { restricted: false }
											},
											{
												term: { archived: false }
											},
											{
												term: { typing_text: 'Prestation' }
											}
										],
										must_not: [
											{
												terms: { tags: ['mixin', 'template'] }
											}
										]
									}
								}
							}
							if (keepStorage) query_b._source.push('storage')
							return EsClient.getData(query_b, 'jobdescriptor')
						})
						.then(response => {
							let jds = response.hits.hits.map(hit => {
								let jd = {
									id: hit._source.descriptor_id,
									label: hit._source.label,
									description: hit._source.description
								}
								if (keepStorage) jd.storage = listToObj(hit._source.storage)
								return jd
							}).sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve(jds)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_sequence_list_light () {
				return new Promise((resolve, reject) => {
					const query_a = {
						_source: '',
						track_total_hits: true,
						size: 0,
						query: {
							bool: {
								must: [
									{
										term: { typing_text: 'Sequence' }
									}
								]
							}
						},
						aggs: {
							jd: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: { order: 'desc' }
												}
											],
											_source: 'id'
										}
									}
								}
							}
						}
					}
					EsClient.getData(query_a, 'jobdescriptor')
						.then(response => {
							let lastVersionIds = response.aggregations.jd.buckets.map(bucket => {
								return bucket.info.hits.hits[0]._source.id
							})
							const query_b = {
								track_total_hits: true,
								size: 10000,
								sort: [{ id: 'desc' }],
								_source: [
									'descriptor_id',
									'label',
									'description'
								],
								query: {
									bool: {
										must: [
											{
												terms: { id: lastVersionIds }
											},
											// {
											// 	term: { restricted: false }
											// },
											{
												term: { archived: false }
											},
											{
												term: { typing_text: 'Sequence' }
											}
										]
									}
								}
							}
							return EsClient.getData(query_b, 'jobdescriptor')
						})
						.then(response => {
							let jds = response.hits.hits.map(hit => {
								let jd = {
									id: hit._source.descriptor_id,
									label: hit._source.label,
									description: hit._source.description
								}
								return jd
							}).sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve(jds)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_list_light_search (stringSearch) {
				return new Promise((resolve, reject) => {
					// format stringSearch
					let queryString = stringSearch.trim().split(' ').map(term => {
						return `*${term}*`
					}).join(' AND ')
					const query = {
						_source: '',
						track_total_hits: true,
						size: 0,
						query: {
							bool: {
								must: [
									{
										query_string: {
											fields: ['label', 'description', 'tags'],
											analyzer: 'standard',
											query: queryString
										}
									}
								]
							}
						},
						aggs: {
							job_descriptors_light: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [
												'descriptor_id',
												'label',
												'description',
												'archived',
												'protected',
												'restricted'
											]
										}
									}
								}
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let jds = []
							if (response.aggregations) {
								response.aggregations.job_descriptors_light.buckets.map(bucket => {
									let jd = {
										id: bucket.key,
										versions: bucket.doc_count,
										label: bucket.info.hits.hits[0]._source.label,
										description: bucket.info.hits.hits[0]._source.description,
										archived: bucket.info.hits.hits[0]._source.archived,
										protected: bucket.info.hits.hits[0]._source.protected,
										restricted: bucket.info.hits.hits[0]._source.restricted
									}
									jds.push(jd)
								})
							}
							jds.sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve(jds)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jd_tags_list () {
				return new Promise((resolve, reject) => {
					const query = {
						_source: {
							includes: [ 'tags' ]
						},
						size: 10000
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let tags = new Set()
							for (let i = 0; i < response.hits.hits.length; i++) {
								const elements = response.hits.hits[i]._source.tags.split(',')
								for (let j = 0; j < elements.length; j++) {
									if (elements[j]) tags.add(elements[j].trim())
								}
							}
							resolve(Array.from(tags).sort())
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_dependents (jobdescriptor_id) {
				return new Promise((resolve, reject) => {
					const query = {
						_source: '',
						track_total_hits: true,
						size: 0,
						query: {
							nested: {
								path: 'tasks',
								query: {
									bool: {
										must: [
											{
												term: {
													'tasks.request_jobdescriptor_id': {
														value: jobdescriptor_id
													}
												}
											}
										]
									}
								}
							}
						},
						aggs: {
							dependents: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [
												'descriptor_id',
												'label',
												'description',
												'archived'
											]
										}
									}
								}
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let dependents = []
							if (response.aggregations) {
								response.aggregations.dependents.buckets.map(bucket => {
									let dependent = {
										id: bucket.key,
										label: bucket.info.hits.hits[0]._source.label,
										description: bucket.info.hits.hits[0]._source.description,
										archived: bucket.info.hits.hits[0]._source.archived
									}
									dependents.push(dependent)
								})
							}
							dependents.sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve(dependents)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			worker_dependents (queue_name) {
				return new Promise((resolve, reject) => {
					const query = {
						_source: '',
						track_total_hits: true,
						size: 0,
						aggs: {
							worker_jds: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: [
												'descriptor_id',
												'label',
												'archived',
												'description',
												'protected'
											]
										}
									}
								}
							}
						},
						query: {
							bool: {
								must: [
									{
										nested: {
											path: 'tasks',
											query: {
												bool: {
													must: [
														{
															term: {
																'tasks.queue_name': {
																	value: queue_name
																}
															}
														}
													]
												}
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let jds = []
							if (response.aggregations) {
								response.aggregations.worker_jds.buckets.map(bucket => {
									let jd = {
										id: bucket.key,
										versions: bucket.doc_count,
										label: bucket.info.hits.hits[0]._source.label,
										description: bucket.info.hits.hits[0]._source.description,
										archived: bucket.info.hits.hits[0]._source.archived,
										protected: bucket.info.hits.hits[0]._source.protected
									}
									jds.push(jd)
								})
							}
							jds.sort((a, b) => {
								if (a.id < b.id) return 1
								if (a.id > b.id) return -1
								return 0
							})
							resolve(jds)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_description (jd_id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1000,
						_source: {
							includes: [
								'id',
								'description',
								'creator',
								'version_number',
								'version_description'
							]
						},
						sort: [
							{ id: { order: 'desc' } }
						],
						query: {
							bool: {
								must: [
									{
										term: {
											descriptor_id: {
												value: jd_id
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let descriptions = hits.map(hit => hit._source)
							resolve(descriptions)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_read (jd_id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1000,
						_source: {
							includes: [
								'id',
								'label',
								'descriptor_id',
								'description',
								'version_number',
								'version_description',
								'parameters',
								'storage',
								'tags'
							]
						},
						sort: [
							{ id: { order: 'desc' } }
						],
						query: {
							bool: {
								must: [
									{
										term: {
											descriptor_id: {
												value: jd_id
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							if (!window.vm.$commons.deepGet(response, 'hits.hits.0', false)) {
								throw new Error('no JD found')
							}
							let versions = response.hits.hits.map(version => {
								let params = descriptorParamsOrFieldsCaster(version._source.parameters)
								return {
									label: response.hits.hits[0]._source.label,
									descriptor_id: response.hits.hits[0]._source.descriptor_id,
									description: response.hits.hits[0]._source.description,
									tags: response.hits.hits[0]._source.tags.split(', '),
									id: version._source.id,
									version_number: version._source.version_number,
									version_description: version._source.version_description,
									parameters: params,
									storage: version._source.storage
								}
							})

							resolve(versions)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_version_read (jd_vers_id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1,
						_source: {
							excludes: [
								'source'
							]
						},
						query: {
							bool: {
								must: [
									{
										term: {
											id: {
												value: jd_vers_id
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							if (!window.vm.$commons.deepGet(response, 'hits.hits.0._source', false)) {
								throw new Error('no JD found')
							}
							resolve(response.hits.hits[0]._source)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_source (jd_vers_id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1000,
						_source: {
							includes: [
								'source'
							]
						},
						sort: [
							{ id: { order: 'desc' } }
						],
						query: {
							bool: {
								must: [
									{
										term: {
											id: {
												value: jd_vers_id
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							resolve(window.vm.$commons.deepGet(response, 'hits.hits.0._source.source', ''))
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_id (jd_label) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1,
						_source: {
							includes: [
								'descriptor_id'
							]
						},
						query: {
							bool: {
								must: [
									{
										term: {
											'label.keyword': {
												value: jd_label
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							resolve(window.vm.$commons.deepGet(response, 'hits.hits.0._source.descriptor_id', false))
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			taskdescriptor_read (taskdescriptorId) {
				return new Promise((resolve, reject) => {
					let query = {
						track_total_hits: true,
						_source: {
							includes: [
								'id',
								'label',
								'tasks.id',
								'tasks.fields',
								'tasks.label'
							]
						},
						size: 1,
						query: {
							bool: {
								must: [
									{
										nested: {
											path: 'tasks',
											query: {
												bool: {
													must: [
														{
															term: {
																'tasks.id': {
																	value: taskdescriptorId
																}
															}
														}
													]
												}
											}
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let taskdescriptor = null
							let tasks = window.vm.$commons.deepGet(response, 'hits.hits.0._source.tasks', [])
							for (let i = 0; i < tasks.length; i++) {
								if (tasks[i].id === taskdescriptorId) {
									taskdescriptor = tasks[i]
									break
								}
							}
							if (taskdescriptor) {
								taskdescriptor.job_descriptor_version = window.vm.$commons.deepGet(response, 'hits.hits.0._source.id', '')
								taskdescriptor.job_descriptor_label = window.vm.$commons.deepGet(response, 'hits.hits.0._source.label', '')
								taskdescriptor.fields = descriptorParamsOrFieldsCaster(taskdescriptor.fields)
								resolve(taskdescriptor)
							} else {
								reject(new Error('taskdescriptor not found'))
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_search (stringSearch, withSource) {
				return new Promise((resolve, reject) => {
					const query_a = {
						_source: '',
						track_total_hits: true,
						size: 0,
						aggs: {
							jd: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: 'id'
										}
									}
								}
							}
						}
					}
					EsClient.getData(query_a, 'jobdescriptor')
						.then(response => {
							let lastVersionIds = response.aggregations.jd.buckets.map(bucket => {
								return bucket.info.hits.hits[0]._source.id
							})
							// format stringSearch
							let queryString = stringSearch.trim().split(' ').map(term => {
								return `*${term}*`
							}).join(' AND ')
							queryString = escapeSpecialChars(queryString)
							let source = [
								'descriptor_id',
								'id',
								'label',
								'archived',
								'description',
								'protected',
								'creator.name',
								'creation_date'
							]
							if (withSource) source.push('source')
							const query_b = {
								track_total_hits: true,
								size: 10000,
								sort: [{ id: 'desc' }],
								_source: source,
								query: {
									bool: {
										must: [
											{
												terms: {
													id: lastVersionIds
												}
											},
											{
												query_string: {
													default_field: 'source',
													analyzer: 'standard',
													query: queryString
												}
											}
										]
									}
								}
							}
							return EsClient.getData(query_b, 'jobdescriptor')
						})
						.then(response => {
							let jds = []
							if (withSource) {
								jds = response.hits.hits.map(hit => {
									return {
										id: hit._source.descriptor_id,
										version_id: hit._source.id,
										label: hit._source.label,
										source: hit._source.source,
										description: hit._source.description,
										archived: hit._source.archived,
										protected: hit._source.protected,
										creator: hit._source.creator.name,
										creation_date: hit._source.creation_date
									}
								})
							} else {
								jds = response.hits.hits.map(hit => {
									return {
										id: hit._source.descriptor_id,
										version_id: hit._source.id,
										label: hit._source.label,
										description: hit._source.description,
										archived: hit._source.archived,
										protected: hit._source.protected,
										creator: hit._source.creator.name,
										creation_date: hit._source.creation_date
									}
								})
							}
							resolve(jds)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			jobdescriptor_descriptions (jd_ids) {
				return new Promise((resolve, reject) => {
					const query = {
						_source: '',
						size: 0,
						query: {
							bool: {
								must: [
									{
										terms: {
											descriptor_id: jd_ids
										}
									}
								]
							}
						},
						aggs: {
							descriptions: {
								terms: {
									field: 'descriptor_id',
									size: 10000
								},
								aggs: {
									info: {
										top_hits: {
											size: 1,
											sort: [
												{
													id: {
														order: 'desc'
													}
												}
											],
											_source: 'description'
										}
									}
								}
							}
						}
					}
					EsClient.getData(query, 'jobdescriptor')
						.then(response => {
							let descriptions = {}
							let buckets = window.vm.$commons.deepGet(response, 'aggregations.descriptions.buckets', [])
							buckets.map(bucket => {
								descriptions[bucket.key] = window.vm.$commons.deepGet(bucket, 'info.hits.hits.0._source.description', '')
							})
							resolve(descriptions)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// ASSET

			asset_get (assetId) {
				return new Promise((resolve, reject) => {
					let query = {
						track_total_hits: true,
						size: 1,
						query: {
							bool: {
								must: [
									{
										term: { 'id': assetId }
									}
								]
							}
						}
					}
					EsClient.getData(query, 'asset')
						.then(response => {
							let results = window.vm.$commons.deepGet(response, 'hits.hits.0._source', null)
							resolve(results)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			assets_search (filters) {
				return new Promise((resolve, reject) => {
					let query = {
						track_total_hits: true,
						size: 10000,
						sort: [{ id: 'desc' }],
						query: {
							bool: {
								must_not: [
									{
										term: {
											behive_category: {
												value: 'deleted'
											}
										}
									},
									{
										term: {
											behive_category: {
												value: 'unknown'
											}
										}
									}
								],
								must: []
							}
						}
					}
					if (filters.search) {
						let refSuifaRegEx = /^[0-9]{2}[/_-][0-9]{2}[/_-][a-zA-Z0-9]{4}$/
						if (refSuifaRegEx.test(filters.search)) {
							query.query.bool.must.push({
								term: {
									'ref_material': {
										value: filters.search.replace(/[/_-]/g, '/')
									}
								}
							})
						} else {
							let fields = [
								'id',
								'resume_detail.subtitle',
								'resume_detail.audio',
								'resume_detail.video',
								'behive_category',
								'title.alternative',
								'title.name',
								'observation',
								'ref_material'
							]

							let queryString = filters.search.trim().split(' ').map(term => {
								return `*${term}*`
							}).join(' AND ')

							query.query.bool.must.push({
								query_string: {
									analyzer: 'standard',
									query: queryString,
									fields: fields
								}
							})
						}
					}

					if (filters.t_aux) {
						query.query.bool.must.push({
							term: {
								't_aux.code': {
									value: filters.t_aux
								}
							}
						})
					}

					if (filters.behive_category) {
						query.query.bool.must.push({
							term: {
								'behive_category': {
									value: filters.behive_category
								}
							}
						})
					}

					if (filters.babel_id) {
						query.query.bool.must.push({
							multi_match: {
								query: filters.babel_id,
								fields: ['title.id', 'babel.id']
							}
						})
					}

					if (filters.has_rv) {
						query.query.bool.must.push({
							term: {
								has_rv: {
									value: filters.has_rv === 1 ? true : false
								}
							}
						})
					}

					if (filters.has_proxy) {
						query.query.bool.must.push({
							term: {
								has_proxy: {
									value: filters.has_proxy === 1 ? true : false
								}
							}
						})
					}

					if (filters.origin) {
						query.query.bool.must.push({
							term: {
								origin: {
									value: filters.origin === 1 ? 'suifa' : 'maestro'
								}
							}
						})
					}

					if (filters.ref_mat) {
						if (RE_ASSET_ID.test(filters.ref_mat)) {
							query.query.bool.must.push({
								term: { 'id': filters.ref_mat }
							})
						} else if (RE_SUIFA_REF.test(filters.ref_mat)) {
							query.query.bool.must.push({
								term: {
									'ref_material': filters.ref_mat.replace(/\\|-|_|\./g, '/')
								}
							})
						}
					}

					if (filters.asset_type_clean) {
						query.query.bool.must.push({
							term: {
								'type_sup.lib_type_sup': {
									value: filters.asset_type_clean
								}
							}
						})
					}

					if (filters.ingest_date_after || filters.ingest_date_before) {
						let ranges = {}
						if (filters.ingest_date_after) ranges.gte = filters.ingest_date_after
						if (filters.ingest_date_before) ranges.lte = filters.ingest_date_before
						query.query.bool.must.push({ range: { 'ingest_date': ranges }
						})
					}

					EsClient.getData(query, 'asset')
						.then(response => {
							let results = window.vm.$commons.deepGet(response, 'hits.hits', null)
							resolve(results)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			asset_from_filepath (filepath) {
				return new Promise((resolve, reject) => {
					filepath = window.vm.$paths.UNCToMaestro(filepath)
					let folderPath = filepath.substring(0, filepath.lastIndexOf('/')) + '/'
					let filename = filepath.substring(filepath.lastIndexOf('/') + 1)
					let suifaRef = null
					let maestroRef = null
					let query = {
						size: 1000,
						query: {
							bool: {
								should: [
									{
										nested: {
											path: 'locations',
											query: {
												match_phrase_prefix: {
													'locations.absolute_path': {
														query: folderPath
													}
												}
											}
										}
									}
								]
							}
						}
					}
					let suifaAssetRE = /^[0-9]{2}_[0-9]{2}_[a-zA-Z0-9]{4}.[a-zA-Z0-9]+$/
					if (suifaAssetRE.test(filename)) {
						suifaRef = filename.replace(/_/g, '/').substring(0, filename.lastIndexOf('.'))
						query.query.bool.should.push({
							term: {
								'ref_material': {
									value: suifaRef
								}
							}
						})
					}
					let maestroAssetRE = /^[0-9]+.[a-zA-Z0-9]+$/
					if (maestroAssetRE.test(filename)) {
						maestroRef = `maestro-${filename.substring(0, filename.lastIndexOf('.'))}`
						query.query.bool.should.push({
							term: {
								'id': {
									value: maestroRef
								}
							}
						})
					}
					EsClient.getData(query, 'asset')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', null)
							let asset = null
							for (const hit of hits) {
								if (suifaRef) {
									if (hit._source.ref_material === suifaRef) {
										asset = hit._source
									}
								}
								if (maestroRef) {
									if (hit._source.id === maestroRef) {
										asset = hit._source
									}
								}
								if (!asset) {
									for (const loc of hit._source.locations) {
										if (loc.absolute_path.substring(loc.path.lastIndexOf('/') + 1) === filename ||
												loc.absolute_path === folderPath) {
											asset = hit._source
											break
										}
									}
								}
								if (asset) break
							}
							if (asset) {
								resolve(asset)
							} else {
								throw new Error('asset_id not found')
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			locations_enums () {
				return new Promise((resolve, reject) => {
					let query = {
						size: 0,
						query: {
							bool: {
								must: [
									{
										nested: {
											path: 'locations',
											query: {
												exists: {
													field: 'locations.id'
												}
											}
										}
									}
								]
							}
						},
						aggs: {
							t_aux: {
								terms: {
									field: 't_aux.name',
									size: 10000
								}
							},
							locations: {
								nested: {
									path: 'locations'
								},
								aggs: {
									category: {
										terms: {
											field: 'locations.storage.category',
											size: 100
										}
									},
									id: {
										terms: {
											field: 'locations.storage.id',
											size: 100
										}
									},
									expiring_jobdescriptor: {
										terms: {
											field: 'locations.expiring.jobdescriptor',
											size: 100
										}
									},
									status: {
										terms: {
											field: 'locations.status',
											size: 100
										},
										aggs: {
											top: {
												top_hits: {
													size: 1,
													_source: ['locations.status_text']
												}
											}
										}
									}
								}
							}
						}
					}
					EsClient.getData(query, 'asset')
						.then(response => {
							let enums = {
								category: response.aggregations.locations.category.buckets,
								storage: response.aggregations.locations.id.buckets,
								expire_jobdescriptor: response.aggregations.locations.expiring_jobdescriptor.buckets,
								t_aux: response.aggregations.t_aux.buckets,
								status: response.aggregations.locations.status.buckets.map(bucket => {
									return {
										value: bucket.key,
										text: bucket.top.hits.hits[0]._source.status_text
									}
								})
							}
							resolve(enums)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			locations_list (filters) {
				return new Promise((resolve, reject) => {
					let computedFrom = (filters.page - 1) * filters.size
					let maxFrom = 10000 - filters.size
					let from = Math.min(computedFrom, maxFrom)
					let sorter = {}
					let sortOrder = filters.sort_asc ? 'asc' : 'desc'
					if (filters.sort === 't_aux') {
						sorter['t_aux.name'] = [{ order: sortOrder }]
					} else if (filters.sort === 'title') {
						sorter['title.name.keyword'] = [{ order: sortOrder }]
					} else if (filters.sort === 'asset_size') {
						sorter['asset_size'] = [{ order: sortOrder }]
					} else if (filters.sort === 'ingest_date') {
						sorter['ingest_date'] = [{ order: sortOrder }]
					} else if (filters.sort === 'creation_date') {
						sorter['locations.creation_date'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'
						}]
					} else if (filters.sort === 'creation_jobrequest') {
						sorter['locations.creation_jobrequest'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'
						}]
					} else if (filters.sort === 'storage.category') {
						sorter['locations.storage.category'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'

						}]
					} else if (filters.sort === 'expiring.date') {
						sorter['locations.expiring.date'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'

						}]
					} else if (filters.sort === 'expiring.jobdescriptor') {
						sorter['locations.expiring.jobdescriptor'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'

						}]
					} else if (filters.sort === 'status') {
						sorter['locations.status_text'] = [{
							order: sortOrder,
							mode: 'max',
							nested_path: 'locations'

						}]
					} else {
						sorter = {
							_script: {
								type: 'number',
								script: {
									lang: 'painless',
									source: "Double.parseDouble(doc['id'].value.splitOnToken('-')[1])"
								},
								order: sortOrder
							}
						}
					}

					let musts = [
						{
							nested: {
								path: 'locations',
								query: {
									exists: {
										field: 'locations.id'
									}
								}
							}
						}
					]

					if (filters.search) {
						if (RE_ASSET_ID.test(filters.search)) {
							musts.push({
								term: { 'id': filters.search }
							})
						} else if (RE_SUIFA_REF.test(filters.search)) {
							musts.push({
								term: {
									'ref_material': filters.search.replace(/(_|-|\/|\\)/g, '/')
								}
							})
						} else {
							musts.push({
								nested: {
									path: 'locations',
									query: {
										match_phrase: {
											'locations.absolute_path': filters.search
										}
									}
								}
							})
						}
					}

					if (filters.expire_after_date || filters.expire_before_date) {
						let ranges = {}
						if (filters.expire_after_date) ranges.gte = filters.expire_after_date
						if (filters.expire_before_date) ranges.lte = filters.expire_before_date
						musts.push({
							nested: {
								path: 'locations',
								query: {
									range: {
										'locations.expiring.date': ranges
									}
								}
							}
						})
					}

					if (filters.category) {
						musts.push({
							nested: {
								path: 'locations',
								query: {
									term: {
										'locations.storage.category': filters.category
									}
								}
							}
						})
					}

					if (filters.status !== '' && filters.status !== undefined) {
						musts.push({
							nested: {
								path: 'locations',
								query: {
									term: {
										'locations.status': filters.status
									}
								}
							}
						})
					}

					if (filters.storage) {
						musts.push({
							nested: {
								path: 'locations',
								query: {
									term: {
										'locations.storage.id': filters.storage
									}
								}
							}
						})
					}

					if (filters.expire_jobdescriptor !== undefined && filters.expire_jobdescriptor !== null) {
						musts.push({
							nested: {
								path: 'locations',
								query: {
									term: {
										'locations.expiring.jobdescriptor': filters.expire_jobdescriptor
									}
								}
							}
						})
					}

					if (filters.t_aux) {
						musts.push({
							term: { 't_aux.name': filters.t_aux }
						})
					}

					let query = {
						track_total_hits: true,
						from: from,
						size: filters.size,
						sort: sorter,
						_source: {
							includes: [
								'locations.absolute_path',
								'locations.storage.id',
								'locations.storage.category',
								'locations.storage.family',
								'locations.status',
								'locations.status_text',
								'locations.creation_date',
								'locations.analysis',
								'locations.creation_jobrequest',
								'locations.expiring.date',
								'locations.expiring.jobdescriptor',
								'locations.expiring.jobrequest_id',
								'title.name',
								'program.type_prgm.lib_type_prgm',
								'type_sup.lib_type_sup',
								'asset_size',
								'ingest_date',
								't_aux.name',
								'behive_category',
								'resume'
							]
						},
						aggs: {
							total: {
								nested: {
									path: 'locations'
								}
							}
						},
						query: {
							bool: {
								must: musts
							}
						}
					}

					EsClient.getData(query, 'asset')
						.then(response => {
							let locations = []
							response.hits.hits.map(hit => {
								hit._source.locations.map(location => {
									location.asset_id = hit._id
									location.resume = hit._source.resume
									location.title = hit._source.title.name
									location.type_pgm = hit._source.program.type_prgm.lib_type_prgm
									location.asset_size = hit._source.asset_size
									location.asset_type = hit._source.type_sup.lib_type_sup
									location.ingest_date = hit._source.ingest_date
									location.t_aux = hit._source.t_aux.name
									location.behive_category = hit._source.behive_category

									let isCandidate = true
									if (filters.search && isCandidate) {
										if (!RE_ASSET_ID.test(filters.search) && !RE_SUIFA_REF.test(filters.search)) {
											if (location.absolute_path.toLowerCase() !== filters.search.toLowerCase()) {
												isCandidate = false
											}
										}
									}

									if (filters.category && isCandidate) {
										if (location.storage.category !== filters.category) {
											isCandidate = false
										}
									}

									if (filters.storage && isCandidate) {
										if (location.storage.id !== filters.storage) {
											isCandidate = false
										}
									}

									if (filters.expire_jobdescriptor !== undefined && filters.expire_jobdescriptor !== null && isCandidate) {
										if (location.expiring.jobdescriptor !== filters.expire_jobdescriptor) {
											isCandidate = false
										}
									}

									if (filters.status !== '' && filters.status !== undefined && isCandidate) {
										if (location.status !== filters.status) {
											isCandidate = false
										}
									}

									if ((filters.expire_after_date || filters.expire_before_date) && isCandidate) {
										if (filters.expire_after_date) {
											if (new Date(filters.expire_after_date) > new Date(location.expiring.date)) {
												isCandidate = false
											}
										}
										if (filters.expire_before_date && isCandidate) {
											if (new Date(filters.expire_before_date) < new Date(location.expiring.date)) {
												isCandidate = false
											}
										}
									}

									if (isCandidate) {
										locations.push(location)
									}
								})
							})

							if (filters.sort === 'storage.category') {
								locations.sort((a, b) => {
									if (a.storage.category < b.storage.category) return filters.sort_asc ? -1 : 1
									if (a.storage.category > b.storage.category) return filters.sort_asc ? 1 : -1
									return 0
								})
							} else if (filters.sort === 'creation_date') {
								locations.sort((a, b) => {
									if (filters.sort_asc) {
										return new Date(b.creation_date) - new Date(a.creation_date)
									} else {
										return new Date(a.creation_date) - new Date(b.creation_date)
									}
								})
							} else if (filters.sort === 'expiring.date') {
								locations.sort((a, b) => {
									if (filters.sort_asc) {
										return new Date(b.expiring.date) - new Date(a.expiring.date)
									} else {
										return new Date(a.expiring.date) - new Date(b.expiring.date)
									}
								})
							} else if (filters.sort === 'expiring.jobdescriptor') {
								locations.sort((a, b) => {
									if (a.expiring.jobdescriptor < b.expiring.jobdescriptor) return filters.sort_asc ? -1 : 1
									if (a.expiring.jobdescriptor > b.expiring.jobdescriptor) return filters.sort_asc ? 1 : -1
									return 0
								})
							} else if (filters.sort === 'status') {
								locations.sort((a, b) => {
									if (a.status_text < b.status_text) return filters.sort_asc ? -1 : 1
									if (a.status_text > b.status_text) return filters.sort_asc ? 1 : -1
									return 0
								})
							} else if (filters.sort === 'creation_jobrequest') {
								locations.sort((a, b) => {
									if (a.creation_jobrequest < b.creation_jobrequest) return filters.sort_asc ? -1 : 1
									if (a.creation_jobrequest > b.creation_jobrequest) return filters.sort_asc ? 1 : -1
									return 0
								})
							}

							resolve({
								locations: locations,
								response: response,
								total: response.aggregations.total.doc_count
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			asset_resume (filters) {
				return new Promise((resolve, reject) => {
					let computedFrom = (filters.page - 1) * filters.size
					let maxFrom = 10000 - filters.size
					let from = Math.min(computedFrom, maxFrom)
					let query = {
						track_total_hits: true,
						from: from,
						size: filters.size,
						_source: {
							includes: [
								'id',
								'resume',
								'audios',
								'qc',
								'subtitles',
								'norm'
							]
						},
						sort: [{ ingest_date: 'desc' }],
						query: {
							bool: {
								must_not: [
									{
										term: {
											behive_category: {
												value: 'deleted'
											}
										}
									},
									{
										term: {
											behive_category: {
												value: 'unknown'
											}
										}
									}
								],
								must: [
									{
										exists: {
											field: 'resume'
										}
									}
								]
							}
						}
					}

					if (filters.maestro_or_suifa) {
						query.query.bool.must.push({
							prefix: {
								id: filters.maestro_or_suifa
							}
						})
					}

					EsClient.getData(query, 'asset')
						.then(response => {
							let results = window.vm.$commons.deepGet(response, 'hits.hits', null)
							resolve(results.map(item => item._source))
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			title_search (stringSearch) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						_source: {
							includes: [ 'title.name', 'title.alternative', 'title.id' ]
						},
						query: {
							bool: {
								must_not: [
									{
										term: {
											behive_category: {
												value: 'deleted'
											}
										}
									},
									{
										term: {
											behive_category: {
												value: 'unknown'
											}
										}
									}
								],
								must: []
							}
						}
					}

					if (stringSearch) {
						stringSearch = escapeSpecialChars(stringSearch)
						let queryString = stringSearch.trim().split(' ').map(term => {
							return `*${term}*`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								analyzer: 'standard',
								query: queryString,
								fields: [
									'title.name',
									'title.alternative'
								]
							}
						})
					}
					EsClient.getData(query, 'asset')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let titles = []
							hits.map(hit => {
								titles.push(hit._source.title.name)
								titles.push(hit._source.title.alternative)
							})
							resolve(titles)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// OWNER

			owner_list () {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						_source: { includes: [ 'code', 'name' ] }
					}
					EsClient.getData(query, 'owner')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let owners = hits.map(hit => hit._source)
							resolve(owners)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			owner_search (stringSearch, code) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						_source: {
							includes: [ 'code', 'name' ]
						},
						query: {
							bool: {
								must: []
							}
						}
					}

					if (stringSearch) {
						stringSearch = escapeSpecialChars(stringSearch)
						let queryString = stringSearch.trim().split(' ').map(term => {
							return `*${term}*`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								analyzer: 'standard',
								query: queryString,
								default_field: 'name'
							}
						})
					}

					if (code) {
						if (!Array.isArray(code)) code = [code]
						query.query.bool.must.push({
							terms: {
								code: code
							}
						})
					}
					EsClient.getData(query, 'owner')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let owners = hits.map(hit => hit._source)
							resolve(owners)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// CONTACT

			contact_list () {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						_source: {
							includes: [ 'id', 'name', 'is_admin' ]
						},
						query: {
							bool: {
								must: [
									{
										term: { is_active: { value: true } }
									},
									{
										term: { is_hiventy: { value: true } }
									}
								]
							}
						}
					}
					EsClient.getData(query, 'contact')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let contacts = hits.map(hit => hit._source)
							resolve(contacts)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			contact_search (stringSearch) {
				return new Promise((resolve, reject) => {
					let queryString = stringSearch.trim().split(' ').map(term => {
						return `*${term}*`
					}).join(' AND ')

					const query = {
						size: 10000,
						_source: {
							includes: [ 'id', 'name', 'email' ]
						},
						query: {
							bool: {
								must: [
									{
										term: {
											is_active: { value: true }
										}
									},
									{
										query_string: {
											analyzer: 'standard',
											query: queryString,
											fields: ['name', 'email']
										}
									}
								]
							}
						}
					}
					EsClient.getData(query, 'contact')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let contacts = hits.map(hit => hit._source)
							resolve(contacts)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// CARDS

			card_search (search) {
				return new Promise((resolve, reject) => {
					let stringSearch = escapeSpecialChars(search.title)
					let queryString = stringSearch.trim().split(' ').map(term => {
						return `*${term}*`
					}).join(' AND ')

					let query = {
						size: 10000,
						_source: {
							includes: [
								'id',
								'label',
								'creation_date',
								'episode_num',
								'last_update',
								'subtype',
								'subtype_text',
								'title_language',
								'type',
								'type_text',
								'data',
								'index',
								'parent.id',
								'parent.label',
								'parent.type',
								'parent.type_text',
								'parent.subtype',
								'parent.subtype_text',
								'parent.title_language',
								'parent.creation_date',
								'parent.last_update',
								'parent.data',
								'parent.index',
								'parent.parent.id',
								'parent.parent.label',
								'parent.parent.type',
								'parent.parent.type_text',
								'parent.parent.subtype',
								'parent.parent.subtype_text',
								'parent.parent.title_language',
								'parent.parent.creation_date',
								'parent.parent.last_update',
								'parent.parent.data',
								'parent.parent.index'
							]
						},
						query: {
							bool: {
								must: [
									{
										query_string: {
											analyzer: 'standard',
											query: queryString,
											fields: ['title', 'parent.title', 'parent.parent.title']
										}
									}
								]
							}
						}
					}
					if (search.type !== null && search.type !== undefined) {
						query.query.bool.must.push({term: {type: {value: search.type}}})
					}
					if (search.sub_type !== null && search.sub_type !== undefined) {
						query.query.bool.must.push({term: {subtype: {value: search.sub_type}}})
					}
					EsClient.getData(query, 'card')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let cards = hits.map(hit => {
								return {
									id: hit._source.id,
									index: hit._source.index,
									label: hit._source.label,
									creation_date: hit._source.creation_date,
									episode_num: hit._source.episode_num,
									last_update: hit._source.last_update,
									subtype: hit._source.subtype,
									subtype_text: hit._source.subtype_text,
									title_language: hit._source.title_language,
									type: hit._source.type,
									type_text: hit._source.type_text,
									data: hit._source.data,
									parent_id: window.vm.$commons.deepGet(hit, '_source.parent.id', ''),
									parent_index: window.vm.$commons.deepGet(hit, '_source.parent.index', ''),
									parent_data: window.vm.$commons.deepGet(hit, '_source.parent.data', ''),
									parent_label: window.vm.$commons.deepGet(hit, '_source.parent.label', ''),
									parent_type: window.vm.$commons.deepGet(hit, '_source.parent.type', ''),
									parent_type_text: window.vm.$commons.deepGet(hit, '_source.parent.type_text', ''),
									parent_subtype: window.vm.$commons.deepGet(hit, '_source.parent.subtype', ''),
									parent_subtype_text: window.vm.$commons.deepGet(hit, '_source.parent.subtype_text', ''),
									parent_title_language: window.vm.$commons.deepGet(hit, '_source.parent.title_language', ''),
									parent_creation_date: window.vm.$commons.deepGet(hit, '_source.parent.creation_date', ''),
									parent_last_update: window.vm.$commons.deepGet(hit, '_source.parent.last_update', ''),
									grand_parent_id: window.vm.$commons.deepGet(hit, '_source.parent.parent.id', ''),
									grand_parent_index: window.vm.$commons.deepGet(hit, '_source.parent.parent.index', ''),
									grand_parent_data: window.vm.$commons.deepGet(hit, '_source.parent.parent.data', ''),
									grand_parent_label: window.vm.$commons.deepGet(hit, '_source.parent.parent.label', ''),
									grand_parent_type: window.vm.$commons.deepGet(hit, '_source.parent.parent.type', ''),
									grand_parent_type_text: window.vm.$commons.deepGet(hit, '_source.parent.parent.type_text', ''),
									grand_parent_subtype: window.vm.$commons.deepGet(hit, '_source.parent.parent.subtype', ''),
									grand_parent_subtype_text: window.vm.$commons.deepGet(hit, '_source.parent.parent.subtype_text', ''),
									grand_parent_title_language: window.vm.$commons.deepGet(hit, '_source.parent.parent.title_language', ''),
									grand_parent_creation_date: window.vm.$commons.deepGet(hit, '_source.parent.parent.creation_date', ''),
									grand_parent_last_update: window.vm.$commons.deepGet(hit, '_source.parent.parent.last_update', '')
								}
							})
							resolve(cards)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			card_read (id, options) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 1,
						query: {
							bool: {
								must: [
									{
										term: {
											id: id
										}
									}
								]
							}
						}
					}
					if (options.only_label) {
						query._source = { includes: [ 'label' ] }
					}
					EsClient.getData(query, 'card')
						.then(response => {
							let card = window.vm.$commons.deepGet(response, 'hits.hits.0._source', false)
							if (!card) {
								return reject(new Error(`Card #${id} not found`))
							}
							resolve(card)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			card_search_or_read (search, card_type) {
				return new Promise((resolve, reject) => {
					let query = {
						size: 10000,
						_source: {
							includes: [
								'id',
								'label',
								'parent.label',
								'parent.parent.label',
								'type_text'
							]
						},
						query: {
							bool: {
								must: []
							}
						}
					}

					if (card_type) {
						query.query.bool.must.push({
							term: {
								type: card_type
							}
						})
					}

					if (Array.isArray(search)) {
						query.query.bool.must.push({
							terms: {
								id: search
							}
						})
					} else if (!isNaN(parseInt(search))) {
						query.query.bool.must.push({
							term: {
								id: {
									value: parseInt(search)
								}
							}
						})
					} else {
						let stringSearch = escapeSpecialChars(search)
						let queryString = stringSearch.trim().split(' ').map(term => {
							return `*${term}*`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								analyzer: 'standard',
								query: queryString,
								fields: ['title', 'parent.title', 'parent.parent.title', 'label']
							}
						})
					}
					EsClient.getData(query, 'card')
						.then(response => {
							let cards = window.vm.$commons.deepGet(response, 'hits.hits', []).map(item => item._source)
							resolve(cards)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			card_from_suifaref (suifa_ref, card_type) {
				return new Promise((resolve, reject) => {
					let query = {
						size: 1,
						_source: {
							includes: ['title.id']
						},
						query: {
							bool: {
								must: [{
									term: {
										ref_material: {
											value: suifa_ref
										}
									}
								}]
							}
						}
					}

					EsClient.getData(query, 'asset')
						.then(response => {
							let card = window.vm.$commons.deepGet(response, 'hits.hits.0._source.title.id', false)
							if (!card) {
								throw new Error('Card not found')
							}
							resolve(this.card_search_or_read(card, card_type))
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// BUNDLES

			bundle_search (search) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						// _source: {
						// 	includes: [ 'code', 'name' ]
						// },
						query: {
							bool: {
								must: []
							}
						}
					}

					if (Array.isArray(search)) {
						query.query.bool.must.push({
							terms: {
								id: search
							}
						})
					} else if (!isNaN(parseInt(search))) {
						query.query.bool.must.push({
							term: {
								id: {
									value: parseInt(search)
								}
							}
						})
					} else {
						let queryString = search.trim().split(' ').map(term => {
							return `*${term}*`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								analyzer: 'standard',
								query: queryString,
								default_field: 'name'
							}
						})
					}

					EsClient.getData(query, 'bundle')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let bundles = hits.map(hit => hit._source)
							resolve(bundles)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// PATRONS

			patron_search (search) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						query: {
							bool: {
								must: []
							}
						}
					}

					search = escapeSpecialChars(search)
					let queryString = search.trim().split(' ').map(term => {
						return `*${term}*`
					}).join(' AND ')
					query.query.bool.must.push({
						query_string: {
							analyzer: 'standard',
							query: queryString,
							fields: [ 'description', 'tags' ]
						}
					})

					EsClient.getData(query, 'patron')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let patrons = hits.map(hit => hit._source)
							resolve(patrons)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			patron_read (id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						query: {
							bool: {
								must: [{
									term: {
										uid: id
									}
								}]
							}
						}
					}

					EsClient.getData(query, 'patron')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let patrons = hits.map(hit => hit._source)
							resolve(patrons)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// PROFILES

			profiles_list (filters) {
				return new Promise((resolve, reject) => {
					let computedFrom = (filters.page - 1) * filters.per_page
					let maxFrom = 10000 - filters.per_page
					let from = Math.min(computedFrom, maxFrom)
					let query = {
						size: filters.per_page,
						from: from,
						track_total_hits: true,
						sort: [],
						query: {
							bool: {
								must: [],
								must_not: []
							}
						}
					}

					let sorter = {}
					let sortKey = filters.sorter || 'id'
					if (sortKey === 'name') sortKey = 'email'
					if (sortKey === 'account_manager') sortKey = 'account_manager.email'
					sorter[sortKey] = filters.sorter_asc ? 'asc' : 'desc'
					query.sort.push(sorter)

					if (filters.id) {
						query.query.bool.must.push({
							term: {
								id: filters.id
							}
						})
					}

					if (filters.profile) {
						query.query.bool.must.push({
							term: {
								profile: filters.profile
							}
						})
					}

					if (filters.search) {
						let search = filters.search.replace(/-|\/|:/g, ' ')
						search = escapeSpecialChars(search)
						search = search.trim().split(' ').map(term => {
							return `*${term}*`
						}).join(' AND ')
						query.query.bool.must.push({
							query_string: {
								query: search,
								analyzer: 'standard',
								fields: [
									'name',
									'email',
									'company',
									'account_manager.name',
									'contract_numeric.name',
									'contract_physic.name',
									'content_owners:name',
									'billing_entities:name'
								]
							}
						})
					}

					if (filters.order_descriptors) {
						query.query.bool.must.push({
							nested: {
								path: 'order_descriptors',
								query: {
									bool: {
										must: [
											{
												terms: {
													'order_descriptors.id': filters.order_descriptors
												}
											}
										]
									}
								}
							}
						})
					}

					if (filters.account_manager) {
						query.query.bool.must.push({
							term: {
								'account_manager.id': filters.account_manager
							}
						})
					}

					if (filters.contract_numeric) {
						if (filters.contract_numeric === 1) {
							query.query.bool.must.push({
								exists: {
									field: 'contract_numeric'
								}
							})
						} else if (filters.contract_numeric === 2) {
							query.query.bool.must_not.push({
								exists: {
									field: 'contract_numeric'
								}
							})
						}
					}

					if (filters.contract_physic) {
						if (filters.contract_physic === 1) {
							query.query.bool.must.push({
								exists: {
									field: 'contract_physic'
								}
							})
						} else if (filters.contract_physic === 2) {
							query.query.bool.must_not.push({
								exists: {
									field: 'contract_physic'
								}
							})
						}
					}

					if (filters.analysis) {
						let analysisQuery = {
							nested: {
								path: 'analysis',
								query: {
									bool: {
										must: [{ exists: { field: 'analysis' } }]
									}
								}
							}
						}
						if (filters.analysis === 1) {
							query.query.bool.must.push(analysisQuery)
						} else if (filters.analysis === 2) {
							query.query.bool.must_not.push(analysisQuery)
						}
					}

					if (filters.analysis_codes) {
						query.query.bool.must.push({
							nested: {
								path: 'analysis',
								query: {
									bool: {
										must: [
											{
												terms: {
													'analysis.code': filters.analysis_codes
												}
											}
										]
									}
								}
							}
						})
					}

					if (filters.is_active) {
						query.query.bool.must.push({
							term: {
								is_active: filters.is_active === 1
							}
						})
					}

					if (filters.is_waiting_for_activation) {
						query.query.bool.must.push({
							term: {
								is_waiting_for_activation: filters.is_waiting_for_activation === 1
							}
						})
					}

					if (filters.is_hiventy) {
						query.query.bool.must.push({
							term: {
								is_hiventy: filters.is_hiventy === 1
							}
						})
					}

					if (filters.is_admin) {
						query.query.bool.must.push({
							term: {
								is_admin: filters.is_admin === 1
							}
						})
					}

					if (filters.is_cdc) {
						query.query.bool.must.push({
							term: {
								is_cdc: filters.is_cdc === 1
							}
						})
					}

					if (filters.is_guest) {
						query.query.bool.must.push({
							term: {
								is_guest: filters.is_guest === 1
							}
						})
					}

					if (filters.can_delete_proxy) {
						query.query.bool.must.push({
							term: {
								can_delete_proxy: filters.can_delete_proxy === 1
							}
						})
					}

					if (filters.can_view_proxy) {
						query.query.bool.must.push({
							term: {
								can_view_proxy: filters.can_view_proxy === 1
							}
						})
					}

					if (filters.can_access_qc) {
						query.query.bool.must.push({
							term: {
								can_access_qc: filters.can_access_qc === 1
							}
						})
					}

					if (filters.can_edit_title) {
						query.query.bool.must.push({
							term: {
								can_edit_title: filters.can_edit_title === 1
							}
						})
					}

					if (filters.can_view_contract) {
						query.query.bool.must.push({
							term: {
								can_view_contract: filters.can_view_contract === 1
							}
						})
					}

					if (filters.can_access_legacy) {
						query.query.bool.must.push({
							term: {
								can_access_legacy: filters.can_access_legacy === 1
							}
						})
					}

					if (filters.is_robot) {
						query.query.bool.must.push({
							term: {
								is_robot: filters.is_robot === 1
							}
						})
					}
					EsClient.getData(query, 'profile')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let profiles = hits.map(hit => hit._source)
							let count = window.vm.$commons.deepGet(response, 'hits.total.value', 0)
							resolve({ profiles: profiles, count: count })
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			profiles_enums () {
				return new Promise((resolve, reject) => {
					let query = {
						_source: '',
						size: 0,
						aggs: {
							analysis: {
								nested: {
									path: 'analysis'
								},
								aggs: {
									code: {
										terms: {
											field: 'analysis.code',
											size: 10000
										},
										aggs: {
											data: {
												top_hits: {
													size: 1,
													_source: ['analysis.level', 'analysis.name']
												}
											}
										}
									}
								}
							},
							order_descriptors: {
								nested: {
									path: 'order_descriptors'
								},
								aggs: {
									sku: {
										terms: {
											field: 'order_descriptors.sku',
											size: 10000
										},
										aggs: {
											data: {
												top_hits: {
													size: 1,
													_source: ['order_descriptors.id', 'order_descriptors.name']
												}
											}
										}
									}
								}
							},
							account_manager: {
								terms: {
									field: 'account_manager.email',
									size: 10000
								},
								aggs: {
									data: {
										top_hits: {
											size: 1,
											_source: ['account_manager.id', 'account_manager.name']
										}
									}
								}
							},
							profiles: {
								terms: {
									field: 'profile',
									size: 10
								}
							}
						}
					}
					EsClient.getData(query, 'profile')
						.then(response => {
							let order_descriptors = window.vm.$commons.deepGet(
								response,
								'aggregations.order_descriptors.sku.buckets',
								[]
							)
							order_descriptors = order_descriptors.map(item => {
								return {
									sku: item.key,
									id: item.data.hits.hits[0]._source.id,
									name: item.data.hits.hits[0]._source.name,
									count: item.doc_count
								}
							}).sort((a, b) => {
								if (a.name > b.name) return 1
								if (a.name < b.name) return -1
								return 0
							})
							let account_manager = window.vm.$commons.deepGet(
								response,
								'aggregations.account_manager.buckets',
								[]
							)
							account_manager = account_manager.map(item => {
								return {
									email: item.key,
									id: item.data.hits.hits[0]._source.account_manager.id,
									name: item.data.hits.hits[0]._source.account_manager.name,
									count: item.doc_count
								}
							}).sort((a, b) => {
								if (a.name > b.name) return 1
								if (a.name < b.name) return -1
								return 0
							})
							let analysis_codes = window.vm.$commons.deepGet(
								response,
								'aggregations.analysis.code.buckets',
								[]
							)
							analysis_codes = analysis_codes.map(item => {
								return {
									code: item.key,
									id: item.data.hits.hits[0]._source.level,
									name: item.data.hits.hits[0]._source.name,
									count: item.doc_count
								}
							}).sort((a, b) => {
								if (a.name > b.name) return 1
								if (a.name < b.name) return -1
								return 0
							})
							let profiles = window.vm.$commons.deepGet(
								response,
								'aggregations.profiles.buckets',
								[]
							)
							profiles = profiles.map(item => {
								return item.key
							}).sort()
							resolve({
								order_descriptors: order_descriptors,
								account_manager: account_manager,
								analysis_codes: analysis_codes,
								profiles: profiles
							})
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			// CONFPLATFORM

			confplatform_read (id) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						query: {
							bool: {
								must: [{
									term: {
										id: id
									}
								}]
							}
						}
					}

					EsClient.getData(query, 'confplateform')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let platforms = hits.map(hit => hit._source)
							resolve(platforms)
						})
						.catch(error => {
							reject(error)
						})
				})
			},

			confplatform_search (search) {
				return new Promise((resolve, reject) => {
					const query = {
						size: 10000,
						query: {
							bool: {
								must: []
							}
						}
					}
					search = escapeSpecialChars(search)
					let queryString = search.trim().split(' ').map(term => {
						return `*${term}*`
					}).join(' AND ')
					query.query.bool.must.push({
						query_string: {
							analyzer: 'standard',
							query: queryString,
							fields: [ 'name', 'description', 'tags', 'owner.name', 'delivery_domain' ]
						}
					})

					EsClient.getData(query, 'confplateform')
						.then(response => {
							let hits = window.vm.$commons.deepGet(response, 'hits.hits', [])
							let platforms = hits.map(hit => hit._source)
							resolve(platforms)
						})
						.catch(error => {
							reject(error)
						})
				})
			}
		}
	}
}

export default EsMaestro



// WEBPACK FOOTER //
// ./src/api/maestro_es.js